const cityOptions = [
  {
    label: "Andaman & Nicobar",
    title: "Andaman & Nicobar",
    options: [
      { label: "Alipur", value: "Alipur" },
      { label: "Andaman Island", value: "Andaman Island" },
      { label: "Anderson Island", value: "Anderson Island" },
      { label: "Arainj-Laka-Punga", value: "Arainj-Laka-Punga" },
      { label: "Austinabad", value: "Austinabad" },
      { label: "Bamboo Flat", value: "Bamboo Flat" },
      { label: "Barren Island", value: "Barren Island" },
      { label: "Beadonabad", value: "Beadonabad" },
      { label: "Betapur", value: "Betapur" },
      { label: "Bindraban", value: "Bindraban" },
      { label: "Bonington", value: "Bonington" },
      { label: "Brookesabad", value: "Brookesabad" },
      { label: "Cadell Point", value: "Cadell Point" },
      { label: "Calicut", value: "Calicut" },
      { label: "Chetamale", value: "Chetamale" },
      { label: "Cinque Islands", value: "Cinque Islands" },
      { label: "Defence Island", value: "Defence Island" },
      { label: "Digilpur", value: "Digilpur" },
      { label: "Dolyganj", value: "Dolyganj" },
      { label: "Flat Island", value: "Flat Island" },
      { label: "Geinyale", value: "Geinyale" },
      { label: "Great Coco Island", value: "Great Coco Island" },
      { label: "Haddo", value: "Haddo" },
      { label: "Havelock Island", value: "Havelock Island" },
      { label: "Henry Lawrence Island", value: "Henry Lawrence Island" },
      { label: "Herbertabad", value: "Herbertabad" },
      { label: "Hobdaypur", value: "Hobdaypur" },
      { label: "Ilichar", value: "Ilichar" },
      { label: "Ingoie", value: "Ingoie" },
      { label: "Inteview Island", value: "Inteview Island" },
      { label: "Jangli Ghat", value: "Jangli Ghat" },
      { label: "Jhon Lawrence Island", value: "Jhon Lawrence Island" },
      { label: "Karen", value: "Karen" },
      { label: "Kartara", value: "Kartara" },
      { label: "KYD Islannd", value: "KYD Islannd" },
      { label: "Landfall Island", value: "Landfall Island" },
      { label: "Little Andmand", value: "Little Andmand" },
      { label: "Little Coco Island", value: "Little Coco Island" },
      { label: "Long Island", value: "Long Island" },
      { label: "Maimyo", value: "Maimyo" },
      { label: "Malappuram", value: "Malappuram" },
      { label: "Manglutan", value: "Manglutan" },
      { label: "Manpur", value: "Manpur" },
      { label: "Mitha Khari", value: "Mitha Khari" },
      { label: "Neill Island", value: "Neill Island" },
      { label: "Nicobar Island", value: "Nicobar Island" },
      { label: "North Brother Island", value: "North Brother Island" },
      { label: "North Passage Island", value: "North Passage Island" },
      { label: "North Sentinel Island", value: "North Sentinel Island" },
      { label: "Nothen Reef Island", value: "Nothen Reef Island" },
      { label: "Outram Island", value: "Outram Island" },
      { label: "Pahlagaon", value: "Pahlagaon" },
      { label: "Palalankwe", value: "Palalankwe" },
      { label: "Passage Island", value: "Passage Island" },
      { label: "Phaiapong", value: "Phaiapong" },
      { label: "Phoenix Island", value: "Phoenix Island" },
      { label: "Port Blair", value: "Port Blair" },
      { label: "Preparis Island", value: "Preparis Island" },
      { label: "Protheroepur", value: "Protheroepur" },
      { label: "Rangachang", value: "Rangachang" },
      { label: "Rongat", value: "Rongat" },
      { label: "Rutland Island", value: "Rutland Island" },
      { label: "Sabari", value: "Sabari" },
      { label: "Saddle Peak", value: "Saddle Peak" },
      { label: "Shadipur", value: "Shadipur" },
      { label: "Smith Island", value: "Smith Island" },
      { label: "Sound Island", value: "Sound Island" },
      { label: "South Sentinel Island", value: "South Sentinel Island" },
      { label: "Spike Island", value: "Spike Island" },
      { label: "Tarmugli Island", value: "Tarmugli Island" },
      { label: "Taylerabad", value: "Taylerabad" },
      { label: "Titaije", value: "Titaije" },
      { label: "Toibalawe", value: "Toibalawe" },
      { label: "Tusonabad", value: "Tusonabad" },
      { label: "West Island", value: "West Island" },
      { label: "Wimberleyganj", value: "Wimberleyganj" },
      { label: "Yadita", value: "Yadita" },
    ],
  },
  {
    label: "Andhra Pradesh",
    title: "Andhra Pradesh",
    options: [
      { label: "Achampet", value: "Achampet" },
      { label: "Adilabad", value: "Adilabad" },
      { label: "Adoni", value: "Adoni" },
      { label: "Alampur", value: "Alampur" },
      { label: "Allagadda", value: "Allagadda" },
      { label: "Alur", value: "Alur" },
      { label: "Amalapuram", value: "Amalapuram" },
      { label: "Amangallu", value: "Amangallu" },
      { label: "Anakapalle", value: "Anakapalle" },
      { label: "Anantapur", value: "Anantapur" },
      { label: "Andole", value: "Andole" },
      { label: "Araku", value: "Araku" },
      { label: "Armoor", value: "Armoor" },
      { label: "Asifabad", value: "Asifabad" },
      { label: "Aswaraopet", value: "Aswaraopet" },
      { label: "Atmakur", value: "Atmakur" },
      { label: "B. Kothakota", value: "B. Kothakota" },
      { label: "Badvel", value: "Badvel" },
      { label: "Banaganapalle", value: "Banaganapalle" },
      { label: "Bandar", value: "Bandar" },
      { label: "Bangarupalem", value: "Bangarupalem" },
      { label: "Banswada", value: "Banswada" },
      { label: "Bapatla", value: "Bapatla" },
      { label: "Bellampalli", value: "Bellampalli" },
      { label: "Bhadrachalam", value: "Bhadrachalam" },
      { label: "Bhainsa", value: "Bhainsa" },
      { label: "Bheemunipatnam", value: "Bheemunipatnam" },
      { label: "Bhimadole", value: "Bhimadole" },
      { label: "Bhimavaram", value: "Bhimavaram" },
      { label: "Bhongir", value: "Bhongir" },
      { label: "Bhooragamphad", value: "Bhooragamphad" },
      { label: "Boath", value: "Boath" },
      { label: "Bobbili", value: "Bobbili" },
      { label: "Bodhan", value: "Bodhan" },
      { label: "Chandoor", value: "Chandoor" },
      { label: "Chavitidibbalu", value: "Chavitidibbalu" },
      { label: "Chejerla", value: "Chejerla" },
      { label: "Chepurupalli", value: "Chepurupalli" },
      { label: "Cherial", value: "Cherial" },
      { label: "Chevella", value: "Chevella" },
      { label: "Chinnor", value: "Chinnor" },
      { label: "Chintalapudi", value: "Chintalapudi" },
      { label: "Chintapalle", value: "Chintapalle" },
      { label: "Chirala", value: "Chirala" },
      { label: "Chittoor", value: "Chittoor" },
      { label: "Chodavaram", value: "Chodavaram" },
      { label: "Cuddapah", value: "Cuddapah" },
      { label: "Cumbum", value: "Cumbum" },
      { label: "Darsi", value: "Darsi" },
      { label: "Devarakonda", value: "Devarakonda" },
      { label: "Dharmavaram", value: "Dharmavaram" },
      { label: "Dichpalli", value: "Dichpalli" },
      { label: "Divi", value: "Divi" },
      { label: "Donakonda", value: "Donakonda" },
      { label: "Dronachalam", value: "Dronachalam" },
      { label: "East Godavari", value: "East Godavari" },
      { label: "Eluru", value: "Eluru" },
      { label: "Eturnagaram", value: "Eturnagaram" },
      { label: "Gadwal", value: "Gadwal" },
      { label: "Gajapathinagaram", value: "Gajapathinagaram" },
      { label: "Gajwel", value: "Gajwel" },
      { label: "Garladinne", value: "Garladinne" },
      { label: "Giddalur", value: "Giddalur" },
      { label: "Godavari", value: "Godavari" },
      { label: "Gooty", value: "Gooty" },
      { label: "Gudivada", value: "Gudivada" },
      { label: "Gudur", value: "Gudur" },
      { label: "Guntur", value: "Guntur" },
      { label: "Hindupur", value: "Hindupur" },
      { label: "Hunsabad", value: "Hunsabad" },
      { label: "Huzurabad", value: "Huzurabad" },
      { label: "Huzurnagar", value: "Huzurnagar" },
      { label: "Hyderabad", value: "Hyderabad" },
      { label: "Ibrahimpatnam", value: "Ibrahimpatnam" },
      { label: "Jaggayyapet", value: "Jaggayyapet" },
      { label: "Jagtial", value: "Jagtial" },
      { label: "Jammalamadugu", value: "Jammalamadugu" },
      { label: "Jangaon", value: "Jangaon" },
      { label: "Jangareddygudem", value: "Jangareddygudem" },
      { label: "Jannaram", value: "Jannaram" },
      { label: "Kadiri", value: "Kadiri" },
      { label: "Kaikaluru", value: "Kaikaluru" },
      { label: "Kakinada", value: "Kakinada" },
      { label: "Kalwakurthy", value: "Kalwakurthy" },
      { label: "Kalyandurg", value: "Kalyandurg" },
      { label: "Kamalapuram", value: "Kamalapuram" },
      { label: "Kamareddy", value: "Kamareddy" },
      { label: "Kambadur", value: "Kambadur" },
      { label: "Kanaganapalle", value: "Kanaganapalle" },
      { label: "Kandukuru", value: "Kandukuru" },
      { label: "Kanigiri", value: "Kanigiri" },
      { label: "Karimnagar", value: "Karimnagar" },
      { label: "Kavali", value: "Kavali" },
      { label: "Khammam", value: "Khammam" },
      { label: "Khanapur (AP)", value: "Khanapur (AP)" },
      { label: "Kodangal", value: "Kodangal" },
      { label: "Koduru", value: "Koduru" },
      { label: "Koilkuntla", value: "Koilkuntla" },
      { label: "Kollapur", value: "Kollapur" },
      { label: "Kothagudem", value: "Kothagudem" },
      { label: "Kovvur", value: "Kovvur" },
      { label: "Krishna", value: "Krishna" },
      { label: "Krosuru", value: "Krosuru" },
      { label: "Kuppam", value: "Kuppam" },
      { label: "Kurnool", value: "Kurnool" },
      { label: "Lakkireddipalli", value: "Lakkireddipalli" },
      { label: "Madakasira", value: "Madakasira" },
      { label: "Madanapalli", value: "Madanapalli" },
      { label: "Madhira", value: "Madhira" },
      { label: "Madnur", value: "Madnur" },
      { label: "Mahabubabad", value: "Mahabubabad" },
      { label: "Mahabubnagar", value: "Mahabubnagar" },
      { label: "Mahadevapur", value: "Mahadevapur" },
      { label: "Makthal", value: "Makthal" },
      { label: "Mancherial", value: "Mancherial" },
      { label: "Mandapeta", value: "Mandapeta" },
      { label: "Mangalagiri", value: "Mangalagiri" },
      { label: "Manthani", value: "Manthani" },
      { label: "Markapur", value: "Markapur" },
      { label: "Marturu", value: "Marturu" },
      { label: "Medachal", value: "Medachal" },
      { label: "Medak", value: "Medak" },
      { label: "Medarmetla", value: "Medarmetla" },
      { label: "Metpalli", value: "Metpalli" },
      { label: "Mriyalguda", value: "Mriyalguda" },
      { label: "Mulug", value: "Mulug" },
      { label: "Mylavaram", value: "Mylavaram" },
      { label: "Nagarkurnool", value: "Nagarkurnool" },
      { label: "Nalgonda", value: "Nalgonda" },
      { label: "Nallacheruvu", value: "Nallacheruvu" },
      { label: "Nampalle", value: "Nampalle" },
      { label: "Nandigama", value: "Nandigama" },
      { label: "Nandikotkur", value: "Nandikotkur" },
      { label: "Nandyal", value: "Nandyal" },
      { label: "Narasampet", value: "Narasampet" },
      { label: "Narasaraopet", value: "Narasaraopet" },
      { label: "Narayanakhed", value: "Narayanakhed" },
      { label: "Narayanpet", value: "Narayanpet" },
      { label: "Narsapur", value: "Narsapur" },
      { label: "Narsipatnam", value: "Narsipatnam" },
      { label: "Nazvidu", value: "Nazvidu" },
      { label: "Nelloe", value: "Nelloe" },
      { label: "Nellore", value: "Nellore" },
      { label: "Nidamanur", value: "Nidamanur" },
      { label: "Nirmal", value: "Nirmal" },
      { label: "Nizamabad", value: "Nizamabad" },
      { label: "Nuguru", value: "Nuguru" },
      { label: "Ongole", value: "Ongole" },
      { label: "Outsarangapalle", value: "Outsarangapalle" },
      { label: "Paderu", value: "Paderu" },
      { label: "Pakala", value: "Pakala" },
      { label: "Palakonda", value: "Palakonda" },
      { label: "Paland", value: "Paland" },
      { label: "Palmaneru", value: "Palmaneru" },
      { label: "Pamuru", value: "Pamuru" },
      { label: "Pargi", value: "Pargi" },
      { label: "Parkal", value: "Parkal" },
      { label: "Parvathipuram", value: "Parvathipuram" },
      { label: "Pathapatnam", value: "Pathapatnam" },
      { label: "Pattikonda", value: "Pattikonda" },
      { label: "Peapalle", value: "Peapalle" },
      { label: "Peddapalli", value: "Peddapalli" },
      { label: "Peddapuram", value: "Peddapuram" },
      { label: "Penukonda", value: "Penukonda" },
      { label: "Piduguralla", value: "Piduguralla" },
      { label: "Piler", value: "Piler" },
      { label: "Pithapuram", value: "Pithapuram" },
      { label: "Podili", value: "Podili" },
      { label: "Polavaram", value: "Polavaram" },
      { label: "Prakasam", value: "Prakasam" },
      { label: "Proddatur", value: "Proddatur" },
      { label: "Pulivendla", value: "Pulivendla" },
      { label: "Punganur", value: "Punganur" },
      { label: "Putturu", value: "Putturu" },
      { label: "Rajahmundri", value: "Rajahmundri" },
      { label: "Rajampeta", value: "Rajampeta" },
      { label: "Ramachandrapuram", value: "Ramachandrapuram" },
      { label: "Ramannapet", value: "Ramannapet" },
      { label: "Rampachodavaram", value: "Rampachodavaram" },
      { label: "Rangareddy", value: "Rangareddy" },
      { label: "Rapur", value: "Rapur" },
      { label: "Rayachoti", value: "Rayachoti" },
      { label: "Rayadurg", value: "Rayadurg" },
      { label: "Razole", value: "Razole" },
      { label: "Repalle", value: "Repalle" },
      { label: "Saluru", value: "Saluru" },
      { label: "Sangareddy", value: "Sangareddy" },
      { label: "Sathupalli", value: "Sathupalli" },
      { label: "Sattenapalle", value: "Sattenapalle" },
      { label: "Satyavedu", value: "Satyavedu" },
      { label: "Shadnagar", value: "Shadnagar" },
      { label: "Siddavattam", value: "Siddavattam" },
      { label: "Siddipet", value: "Siddipet" },
      { label: "Sileru", value: "Sileru" },
      { label: "Sircilla", value: "Sircilla" },
      { label: "Sirpur Kagaznagar", value: "Sirpur Kagaznagar" },
      { label: "Sodam", value: "Sodam" },
      { label: "Sompeta", value: "Sompeta" },
      { label: "Srikakulam", value: "Srikakulam" },
      { label: "Srikalahasthi", value: "Srikalahasthi" },
      { label: "Srisailam", value: "Srisailam" },
      { label: "Srungavarapukota", value: "Srungavarapukota" },
      { label: "Sudhimalla", value: "Sudhimalla" },
      { label: "Sullarpet", value: "Sullarpet" },
      { label: "Tadepalligudem", value: "Tadepalligudem" },
      { label: "Tadipatri", value: "Tadipatri" },
      { label: "Tanduru", value: "Tanduru" },
      { label: "Tanuku", value: "Tanuku" },
      { label: "Tekkali", value: "Tekkali" },
      { label: "Tenali", value: "Tenali" },
      { label: "Thungaturthy", value: "Thungaturthy" },
      { label: "Tirivuru", value: "Tirivuru" },
      { label: "Tirupathi", value: "Tirupathi" },
      { label: "Tuni", value: "Tuni" },
      { label: "Udaygiri", value: "Udaygiri" },
      { label: "Ulvapadu", value: "Ulvapadu" },
      { label: "Uravakonda", value: "Uravakonda" },
      { label: "Utnor", value: "Utnor" },
      { label: "V.R. Puram", value: "V.R. Puram" },
      { label: "Vaimpalli", value: "Vaimpalli" },
      { label: "Vayalpad", value: "Vayalpad" },
      { label: "Venkatgiri", value: "Venkatgiri" },
      { label: "Venkatgirikota", value: "Venkatgirikota" },
      { label: "Vijayawada", value: "Vijayawada" },
      { label: "Vikrabad", value: "Vikrabad" },
      { label: "Vinjamuru", value: "Vinjamuru" },
      { label: "Vinukonda", value: "Vinukonda" },
      { label: "Visakhapatnam", value: "Visakhapatnam" },
      { label: "Vizayanagaram", value: "Vizayanagaram" },
      { label: "Vizianagaram", value: "Vizianagaram" },
      { label: "Vuyyuru", value: "Vuyyuru" },
      { label: "Wanaparthy", value: "Wanaparthy" },
      { label: "Warangal", value: "Warangal" },
      { label: "Wardhannapet", value: "Wardhannapet" },
      { label: "Yelamanchili", value: "Yelamanchili" },
      { label: "Yelavaram", value: "Yelavaram" },
      { label: "Yeleswaram", value: "Yeleswaram" },
      { label: "Yellandu", value: "Yellandu" },
      { label: "Yellanuru", value: "Yellanuru" },
      { label: "Yellareddy", value: "Yellareddy" },
      { label: "Yerragondapalem", value: "Yerragondapalem" },
      { label: "Zahirabad", value: "Zahirabad" },
    ],
  },
  {
    label: "Arunachal Pradesh",
    title: "Arunachal Pradesh",
    options: [
      { label: "Along", value: "Along" },
      { label: "Anini", value: "Anini" },
      { label: "Anjaw", value: "Anjaw" },
      { label: "Bameng", value: "Bameng" },
      { label: "Basar", value: "Basar" },
      { label: "Changlang", value: "Changlang" },
      { label: "Chowkhem", value: "Chowkhem" },
      { label: "Daporizo", value: "Daporizo" },
      { label: "Dibang Valley", value: "Dibang Valley" },
      { label: "Dirang", value: "Dirang" },
      { label: "Hayuliang", value: "Hayuliang" },
      { label: "Huri", value: "Huri" },
      { label: "Itanagar", value: "Itanagar" },
      { label: "Jairampur", value: "Jairampur" },
      { label: "Kalaktung", value: "Kalaktung" },
      { label: "Kameng", value: "Kameng" },
      { label: "Khonsa", value: "Khonsa" },
      { label: "Kolaring", value: "Kolaring" },
      { label: "Kurung Kumey", value: "Kurung Kumey" },
      { label: "Lohit", value: "Lohit" },
      { label: "Lower Dibang Valley", value: "Lower Dibang Valley" },
      { label: "Lower Subansiri", value: "Lower Subansiri" },
      { label: "Mariyang", value: "Mariyang" },
      { label: "Mechuka", value: "Mechuka" },
      { label: "Miao", value: "Miao" },
      { label: "Nefra", value: "Nefra" },
      { label: "Pakkekesang", value: "Pakkekesang" },
      { label: "Pangin", value: "Pangin" },
      { label: "Papum Pare", value: "Papum Pare" },
      { label: "Passighat", value: "Passighat" },
      { label: "Roing", value: "Roing" },
      { label: "Sagalee", value: "Sagalee" },
      { label: "Seppa", value: "Seppa" },
      { label: "Siang", value: "Siang" },
      { label: "Tali", value: "Tali" },
      { label: "Taliha", value: "Taliha" },
      { label: "Tawang", value: "Tawang" },
      { label: "Tezu", value: "Tezu" },
      { label: "Tirap", value: "Tirap" },
      { label: "Tuting", value: "Tuting" },
      { label: "Upper Siang", value: "Upper Siang" },
      { label: "Upper Subansiri", value: "Upper Subansiri" },
      { label: "Yiang Kiag", value: "Yiang Kiag" },
    ],
  },
  {
    label: "Assam",
    title: "Assam",
    options: [
      { label: "Abhayapuri", value: "Abhayapuri" },
      { label: "Baithalangshu", value: "Baithalangshu" },
      { label: "Barama", value: "Barama" },
      { label: "Barpeta Road", value: "Barpeta Road" },
      { label: "Bihupuria", value: "Bihupuria" },
      { label: "Bijni", value: "Bijni" },
      { label: "Bilasipara", value: "Bilasipara" },
      { label: "Bokajan", value: "Bokajan" },
      { label: "Bokakhat", value: "Bokakhat" },
      { label: "Boko", value: "Boko" },
      { label: "Bongaigaon", value: "Bongaigaon" },
      { label: "Cachar", value: "Cachar" },
      { label: "Cachar Hills", value: "Cachar Hills" },
      { label: "Darrang", value: "Darrang" },
      { label: "Dhakuakhana", value: "Dhakuakhana" },
      { label: "Dhemaji", value: "Dhemaji" },
      { label: "Dhubri", value: "Dhubri" },
      { label: "Dibrugarh", value: "Dibrugarh" },
      { label: "Digboi", value: "Digboi" },
      { label: "Diphu", value: "Diphu" },
      { label: "Goalpara", value: "Goalpara" },
      { label: "Gohpur", value: "Gohpur" },
      { label: "Golaghat", value: "Golaghat" },
      { label: "Guwahati", value: "Guwahati" },
      { label: "Hailakandi", value: "Hailakandi" },
      { label: "Hajo", value: "Hajo" },
      { label: "Halflong", value: "Halflong" },
      { label: "Hojai", value: "Hojai" },
      { label: "Howraghat", value: "Howraghat" },
      { label: "Jorhat", value: "Jorhat" },
      { label: "Kamrup", value: "Kamrup" },
      { label: "Karbi Anglong", value: "Karbi Anglong" },
      { label: "Karimganj", value: "Karimganj" },
      { label: "Kokarajhar", value: "Kokarajhar" },
      { label: "Kokrajhar", value: "Kokrajhar" },
      { label: "Lakhimpur", value: "Lakhimpur" },
      { label: "Maibong", value: "Maibong" },
      { label: "Majuli", value: "Majuli" },
      { label: "Mangaldoi", value: "Mangaldoi" },
      { label: "Mariani", value: "Mariani" },
      { label: "Marigaon", value: "Marigaon" },
      { label: "Moranhat", value: "Moranhat" },
      { label: "Morigaon", value: "Morigaon" },
      { label: "Nagaon", value: "Nagaon" },
      { label: "Nalbari", value: "Nalbari" },
      { label: "Rangapara", value: "Rangapara" },
      { label: "Sadiya", value: "Sadiya" },
      { label: "Sibsagar", value: "Sibsagar" },
      { label: "Silchar", value: "Silchar" },
      { label: "Sivasagar", value: "Sivasagar" },
      { label: "Sonitpur", value: "Sonitpur" },
      { label: "Tarabarihat", value: "Tarabarihat" },
      { label: "Tezpur", value: "Tezpur" },
      { label: "Tinsukia", value: "Tinsukia" },
      { label: "Udalgiri", value: "Udalgiri" },
      { label: "Udalguri", value: "Udalguri" },
      { label: "UdarbondhBarpeta", value: "UdarbondhBarpeta" },
    ],
  },
  {
    label: "Bihar",
    title: "Bihar",
    options: [
      { label: "Adhaura", value: "Adhaura" },
      { label: "Amarpur", value: "Amarpur" },
      { label: "Araria", value: "Araria" },
      { label: "Areraj", value: "Areraj" },
      { label: "Arrah", value: "Arrah" },
      { label: "Arwal", value: "Arwal" },
      { label: "Aurangabad", value: "Aurangabad" },
      { label: "Bagaha", value: "Bagaha" },
      { label: "Banka", value: "Banka" },
      { label: "Banmankhi", value: "Banmankhi" },
      { label: "Barachakia", value: "Barachakia" },
      { label: "Barauni", value: "Barauni" },
      { label: "Barh", value: "Barh" },
      { label: "Barosi", value: "Barosi" },
      { label: "Begusarai", value: "Begusarai" },
      { label: "Benipatti", value: "Benipatti" },
      { label: "Benipur", value: "Benipur" },
      { label: "Bettiah", value: "Bettiah" },
      { label: "Bhabhua", value: "Bhabhua" },
      { label: "Bhagalpur", value: "Bhagalpur" },
      { label: "Bhojpur", value: "Bhojpur" },
      { label: "Bidupur", value: "Bidupur" },
      { label: "Biharsharif", value: "Biharsharif" },
      { label: "Bikram", value: "Bikram" },
      { label: "Bikramganj", value: "Bikramganj" },
      { label: "Birpur", value: "Birpur" },
      { label: "Buxar", value: "Buxar" },
      { label: "Chakai", value: "Chakai" },
      { label: "Champaran", value: "Champaran" },
      { label: "Chapara", value: "Chapara" },
      { label: "Dalsinghsarai", value: "Dalsinghsarai" },
      { label: "Danapur", value: "Danapur" },
      { label: "Darbhanga", value: "Darbhanga" },
      { label: "Daudnagar", value: "Daudnagar" },
      { label: "Dhaka", value: "Dhaka" },
      { label: "Dhamdaha", value: "Dhamdaha" },
      { label: "Dumraon", value: "Dumraon" },
      { label: "Ekma", value: "Ekma" },
      { label: "Forbesganj", value: "Forbesganj" },
      { label: "Gaya", value: "Gaya" },
      { label: "Gogri", value: "Gogri" },
      { label: "Gopalganj", value: "Gopalganj" },
      { label: "H.Kharagpur", value: "H.Kharagpur" },
      { label: "Hajipur", value: "Hajipur" },
      { label: "Hathua", value: "Hathua" },
      { label: "Hilsa", value: "Hilsa" },
      { label: "Imamganj", value: "Imamganj" },
      { label: "Jahanabad", value: "Jahanabad" },
      { label: "Jainagar", value: "Jainagar" },
      { label: "Jamshedpur", value: "Jamshedpur" },
      { label: "Jamui", value: "Jamui" },
      { label: "Jehanabad", value: "Jehanabad" },
      { label: "Jhajha", value: "Jhajha" },
      { label: "Jhanjharpur", value: "Jhanjharpur" },
      { label: "Kahalgaon", value: "Kahalgaon" },
      { label: "Kaimur (Bhabua)", value: "Kaimur (Bhabua)" },
      { label: "Katihar", value: "Katihar" },
      { label: "Katoria", value: "Katoria" },
      { label: "Khagaria", value: "Khagaria" },
      { label: "Kishanganj", value: "Kishanganj" },
      { label: "Korha", value: "Korha" },
      { label: "Lakhisarai", value: "Lakhisarai" },
      { label: "Madhepura", value: "Madhepura" },
      { label: "Madhubani", value: "Madhubani" },
      { label: "Maharajganj", value: "Maharajganj" },
      { label: "Mahua", value: "Mahua" },
      { label: "Mairwa", value: "Mairwa" },
      { label: "Mallehpur", value: "Mallehpur" },
      { label: "Masrakh", value: "Masrakh" },
      { label: "Mohania", value: "Mohania" },
      { label: "Monghyr", value: "Monghyr" },
      { label: "Motihari", value: "Motihari" },
      { label: "Motipur", value: "Motipur" },
      { label: "Munger", value: "Munger" },
      { label: "Muzaffarpur", value: "Muzaffarpur" },
      { label: "Nabinagar", value: "Nabinagar" },
      { label: "Nalanda", value: "Nalanda" },
      { label: "Narkatiaganj", value: "Narkatiaganj" },
      { label: "Naugachia", value: "Naugachia" },
      { label: "Nawada", value: "Nawada" },
      { label: "Pakribarwan", value: "Pakribarwan" },
      { label: "Pakridayal", value: "Pakridayal" },
      { label: "Patna", value: "Patna" },
      { label: "Phulparas", value: "Phulparas" },
      { label: "Piro", value: "Piro" },
      { label: "Pupri", value: "Pupri" },
      { label: "Purena", value: "Purena" },
      { label: "Purnia", value: "Purnia" },
      { label: "Rafiganj", value: "Rafiganj" },
      { label: "Rajauli", value: "Rajauli" },
      { label: "Ramnagar", value: "Ramnagar" },
      { label: "Raniganj", value: "Raniganj" },
      { label: "Raxaul", value: "Raxaul" },
      { label: "Rohtas", value: "Rohtas" },
      { label: "Rosera", value: "Rosera" },
      { label: "S.Bakhtiarpur", value: "S.Bakhtiarpur" },
      { label: "Saharsa", value: "Saharsa" },
      { label: "Samastipur", value: "Samastipur" },
      { label: "Saran", value: "Saran" },
      { label: "Sasaram", value: "Sasaram" },
      { label: "Seikhpura", value: "Seikhpura" },
      { label: "Sheikhpura", value: "Sheikhpura" },
      { label: "Sheohar", value: "Sheohar" },
      { label: "Sherghati", value: "Sherghati" },
      { label: "Sidhawalia", value: "Sidhawalia" },
      { label: "Singhwara", value: "Singhwara" },
      { label: "Sitamarhi", value: "Sitamarhi" },
      { label: "Siwan", value: "Siwan" },
      { label: "Sonepur", value: "Sonepur" },
      { label: "Supaul", value: "Supaul" },
      { label: "Thakurganj", value: "Thakurganj" },
      { label: "Triveniganj", value: "Triveniganj" },
      { label: "Udakishanganj", value: "Udakishanganj" },
      { label: "Vaishali", value: "Vaishali" },
      { label: "Wazirganj", value: "Wazirganj" },
    ],
  },
  {
    label: "Chandigarh",
    title: "Chandigarh",
    options: [
      { label: "Chandigarh", value: "Chandigarh" },
      { label: "Mani Marja", value: "Mani Marja" },
    ],
  },
  {
    label: "Chhattisgarh",
    title: "Chhattisgarh",
    options: [
      { label: "Ambikapur", value: "Ambikapur" },
      { label: "Antagarh", value: "Antagarh" },
      { label: "Arang", value: "Arang" },
      { label: "Bacheli", value: "Bacheli" },
      { label: "Bagbahera", value: "Bagbahera" },
      { label: "Bagicha", value: "Bagicha" },
      { label: "Baikunthpur", value: "Baikunthpur" },
      { label: "Balod", value: "Balod" },
      { label: "Balodabazar", value: "Balodabazar" },
      { label: "Balrampur", value: "Balrampur" },
      { label: "Barpalli", value: "Barpalli" },
      { label: "Basana", value: "Basana" },
      { label: "Bastanar", value: "Bastanar" },
      { label: "Bastar", value: "Bastar" },
      { label: "Bderajpur", value: "Bderajpur" },
      { label: "Bemetara", value: "Bemetara" },
      { label: "Berla", value: "Berla" },
      { label: "Bhairongarh", value: "Bhairongarh" },
      { label: "Bhanupratappur", value: "Bhanupratappur" },
      { label: "Bharathpur", value: "Bharathpur" },
      { label: "Bhatapara", value: "Bhatapara" },
      { label: "Bhilai", value: "Bhilai" },
      { label: "Bhilaigarh", value: "Bhilaigarh" },
      { label: "Bhopalpatnam", value: "Bhopalpatnam" },
      { label: "Bijapur", value: "Bijapur" },
      { label: "Bilaspur", value: "Bilaspur" },
      { label: "Bodla", value: "Bodla" },
      { label: "Bokaband", value: "Bokaband" },
      { label: "Chandipara", value: "Chandipara" },
      { label: "Chhinagarh", value: "Chhinagarh" },
      { label: "Chhuriakala", value: "Chhuriakala" },
      { label: "Chingmut", value: "Chingmut" },
      { label: "Chuikhadan", value: "Chuikhadan" },
      { label: "Dabhara", value: "Dabhara" },
      { label: "Dallirajhara", value: "Dallirajhara" },
      { label: "Dantewada", value: "Dantewada" },
      { label: "Deobhog", value: "Deobhog" },
      { label: "Dhamda", value: "Dhamda" },
      { label: "Dhamtari", value: "Dhamtari" },
      { label: "Dharamjaigarh", value: "Dharamjaigarh" },
      { label: "Dongargarh", value: "Dongargarh" },
      { label: "Durg", value: "Durg" },
      { label: "Durgakondal", value: "Durgakondal" },
      { label: "Fingeshwar", value: "Fingeshwar" },
      { label: "Gariaband", value: "Gariaband" },
      { label: "Garpa", value: "Garpa" },
      { label: "Gharghoda", value: "Gharghoda" },
      { label: "Gogunda", value: "Gogunda" },
      { label: "Ilamidi", value: "Ilamidi" },
      { label: "Jagdalpur", value: "Jagdalpur" },
      { label: "Janjgir", value: "Janjgir" },
      { label: "Janjgir-Champa", value: "Janjgir-Champa" },
      { label: "Jarwa", value: "Jarwa" },
      { label: "Jashpur", value: "Jashpur" },
      { label: "Jashpurnagar", value: "Jashpurnagar" },
      { label: "Kabirdham-Kawardha", value: "Kabirdham-Kawardha" },
      { label: "Kanker", value: "Kanker" },
      { label: "Kasdol", value: "Kasdol" },
      { label: "Kathdol", value: "Kathdol" },
      { label: "Kathghora", value: "Kathghora" },
      { label: "Kawardha", value: "Kawardha" },
      { label: "Keskal", value: "Keskal" },
      { label: "Khairgarh", value: "Khairgarh" },
      { label: "Kondagaon", value: "Kondagaon" },
      { label: "Konta", value: "Konta" },
      { label: "Korba", value: "Korba" },
      { label: "Korea", value: "Korea" },
      { label: "Kota", value: "Kota" },
      { label: "Koyelibeda", value: "Koyelibeda" },
      { label: "Kuakunda", value: "Kuakunda" },
      { label: "Kunkuri", value: "Kunkuri" },
      { label: "Kurud", value: "Kurud" },
      { label: "Lohadigundah", value: "Lohadigundah" },
      { label: "Lormi", value: "Lormi" },
      { label: "Luckwada", value: "Luckwada" },
      { label: "Mahasamund", value: "Mahasamund" },
      { label: "Makodi", value: "Makodi" },
      { label: "Manendragarh", value: "Manendragarh" },
      { label: "Manpur", value: "Manpur" },
      { label: "Marwahi", value: "Marwahi" },
      { label: "Mohla", value: "Mohla" },
      { label: "Mungeli", value: "Mungeli" },
      { label: "Nagri", value: "Nagri" },
      { label: "Narainpur", value: "Narainpur" },
      { label: "Narayanpur", value: "Narayanpur" },
      { label: "Neora", value: "Neora" },
      { label: "Netanar", value: "Netanar" },
      { label: "Odgi", value: "Odgi" },
      { label: "Padamkot", value: "Padamkot" },
      { label: "Pakhanjur", value: "Pakhanjur" },
      { label: "Pali", value: "Pali" },
      { label: "Pandaria", value: "Pandaria" },
      { label: "Pandishankar", value: "Pandishankar" },
      { label: "Parasgaon", value: "Parasgaon" },
      { label: "Pasan", value: "Pasan" },
      { label: "Patan", value: "Patan" },
      { label: "Pathalgaon", value: "Pathalgaon" },
      { label: "Pendra", value: "Pendra" },
      { label: "Pratappur", value: "Pratappur" },
      { label: "Premnagar", value: "Premnagar" },
      { label: "Raigarh", value: "Raigarh" },
      { label: "Raipur", value: "Raipur" },
      { label: "Rajnandgaon", value: "Rajnandgaon" },
      { label: "Rajpur", value: "Rajpur" },
      { label: "Ramchandrapur", value: "Ramchandrapur" },
      { label: "Saraipali", value: "Saraipali" },
      { label: "Saranggarh", value: "Saranggarh" },
      { label: "Sarona", value: "Sarona" },
      { label: "Semaria", value: "Semaria" },
      { label: "Shakti", value: "Shakti" },
      { label: "Sitapur", value: "Sitapur" },
      { label: "Sukma", value: "Sukma" },
      { label: "Surajpur", value: "Surajpur" },
      { label: "Surguja", value: "Surguja" },
      { label: "Tapkara", value: "Tapkara" },
      { label: "Toynar", value: "Toynar" },
      { label: "Udaipur", value: "Udaipur" },
      { label: "Uproda", value: "Uproda" },
      { label: "Wadrainagar", value: "Wadrainagar" },
    ],
  },
  {
    label: "Dadra & Nagar Haveli",
    title: "Dadra & Nagar Haveli",
    options: [
      { label: "Amal", value: "Amal" },
      { label: "Amli", value: "Amli" },
      { label: "Bedpa", value: "Bedpa" },
      { label: "Chikhli", value: "Chikhli" },
      { label: "Dadra & Nagar Haveli", value: "Dadra & Nagar Haveli" },
      { label: "Dahikhed", value: "Dahikhed" },
      { label: "Dolara", value: "Dolara" },
      { label: "Galonda", value: "Galonda" },
      { label: "Kanadi", value: "Kanadi" },
      { label: "Karchond", value: "Karchond" },
      { label: "Khadoli", value: "Khadoli" },
      { label: "Kharadpada", value: "Kharadpada" },
      { label: "Kherabari", value: "Kherabari" },
      { label: "Kherdi", value: "Kherdi" },
      { label: "Kothar", value: "Kothar" },
      { label: "Luari", value: "Luari" },
      { label: "Mashat", value: "Mashat" },
      { label: "Rakholi", value: "Rakholi" },
      { label: "Rudana", value: "Rudana" },
      { label: "Saili", value: "Saili" },
      { label: "Sili", value: "Sili" },
      { label: "Silvassa", value: "Silvassa" },
      { label: "Sindavni", value: "Sindavni" },
      { label: "Udva", value: "Udva" },
      { label: "Umbarkoi", value: "Umbarkoi" },
      { label: "Vansda", value: "Vansda" },
      { label: "Vasona", value: "Vasona" },
      { label: "Velugam", value: "Velugam" },
    ],
  },
  {
    label: "Daman & Diu",
    title: "Daman & Diu",
    options: [
      { label: "Brancavare", value: "Brancavare" },
      { label: "Dagasi", value: "Dagasi" },
      { label: "Daman", value: "Daman" },
      { label: "Diu", value: "Diu" },
      { label: "Magarvara", value: "Magarvara" },
      { label: "Nagwa", value: "Nagwa" },
      { label: "Pariali", value: "Pariali" },
      { label: "Passo Covo", value: "Passo Covo" },
    ],
  },
  {
    label: "Delhi",
    title: "Delhi",
    options: [
      { label: "Central Delhi", value: "Central Delhi" },
      { label: "East Delhi", value: "East Delhi" },
      { label: "New Delhi", value: "New Delhi" },
      { label: "North Delhi", value: "North Delhi" },
      { label: "North East Delhi", value: "North East Delhi" },
      { label: "North West Delhi", value: "North West Delhi" },
      { label: "South Delhi", value: "South Delhi" },
      { label: "South West Delhi", value: "South West Delhi" },
      { label: "West Delhi", value: "West Delhi" },
    ],
  },
  {
    label: "Goa",
    title: "Goa",
    options: [
      { label: "Canacona", value: "Canacona" },
      { label: "Candolim", value: "Candolim" },
      { label: "Chinchinim", value: "Chinchinim" },
      { label: "Cortalim", value: "Cortalim" },
      { label: "Goa", value: "Goa" },
      { label: "Jua", value: "Jua" },
      { label: "Madgaon", value: "Madgaon" },
      { label: "Mahem", value: "Mahem" },
      { label: "Mapuca", value: "Mapuca" },
      { label: "Marmagao", value: "Marmagao" },
      { label: "Panji", value: "Panji" },
      { label: "Ponda", value: "Ponda" },
      { label: "Sanvordem", value: "Sanvordem" },
      { label: "Terekhol", value: "Terekhol" },
    ],
  },
  {
    label: "Gujarat",
    title: "Gujarat",
    options: [
      { label: "Ahmedabad", value: "Ahmedabad" },
      { label: "Ahwa", value: "Ahwa" },
      { label: "Amod", value: "Amod" },
      { label: "Amreli", value: "Amreli" },
      { label: "Anand", value: "Anand" },
      { label: "Anjar", value: "Anjar" },
      { label: "Ankaleshwar", value: "Ankaleshwar" },
      { label: "Babra", value: "Babra" },
      { label: "Balasinor", value: "Balasinor" },
      { label: "Banaskantha", value: "Banaskantha" },
      { label: "Bansada", value: "Bansada" },
      { label: "Bardoli", value: "Bardoli" },
      { label: "Bareja", value: "Bareja" },
      { label: "Baroda", value: "Baroda" },
      { label: "Barwala", value: "Barwala" },
      { label: "Bayad", value: "Bayad" },
      { label: "Bhachav", value: "Bhachav" },
      { label: "Bhanvad", value: "Bhanvad" },
      { label: "Bharuch", value: "Bharuch" },
      { label: "Bhavnagar", value: "Bhavnagar" },
      { label: "Bhiloda", value: "Bhiloda" },
      { label: "Bhuj", value: "Bhuj" },
      { label: "Billimora", value: "Billimora" },
      { label: "Borsad", value: "Borsad" },
      { label: "Botad", value: "Botad" },
      { label: "Chanasma", value: "Chanasma" },
      { label: "Chhota Udaipur", value: "Chhota Udaipur" },
      { label: "Chotila", value: "Chotila" },
      { label: "Dabhoi", value: "Dabhoi" },
      { label: "Dahod", value: "Dahod" },
      { label: "Damnagar", value: "Damnagar" },
      { label: "Dang", value: "Dang" },
      { label: "Danta", value: "Danta" },
      { label: "Dasada", value: "Dasada" },
      { label: "Dediapada", value: "Dediapada" },
      { label: "Deesa", value: "Deesa" },
      { label: "Dehgam", value: "Dehgam" },
      { label: "Deodar", value: "Deodar" },
      { label: "Devgadhbaria", value: "Devgadhbaria" },
      { label: "Dhandhuka", value: "Dhandhuka" },
      { label: "Dhanera", value: "Dhanera" },
      { label: "Dharampur", value: "Dharampur" },
      { label: "Dhari", value: "Dhari" },
      { label: "Dholka", value: "Dholka" },
      { label: "Dhoraji", value: "Dhoraji" },
      { label: "Dhrangadhra", value: "Dhrangadhra" },
      { label: "Dhrol", value: "Dhrol" },
      { label: "Dwarka", value: "Dwarka" },
      { label: "Fortsongadh", value: "Fortsongadh" },
      { label: "Gadhada", value: "Gadhada" },
      { label: "Gandhi Nagar", value: "Gandhi Nagar" },
      { label: "Gariadhar", value: "Gariadhar" },
      { label: "Godhra", value: "Godhra" },
      { label: "Gogodar", value: "Gogodar" },
      { label: "Gondal", value: "Gondal" },
      { label: "Halol", value: "Halol" },
      { label: "Halvad", value: "Halvad" },
      { label: "Harij", value: "Harij" },
      { label: "Himatnagar", value: "Himatnagar" },
      { label: "Idar", value: "Idar" },
      { label: "Jambusar", value: "Jambusar" },
      { label: "Jamjodhpur", value: "Jamjodhpur" },
      { label: "Jamkalyanpur", value: "Jamkalyanpur" },
      { label: "Jamnagar", value: "Jamnagar" },
      { label: "Jasdan", value: "Jasdan" },
      { label: "Jetpur", value: "Jetpur" },
      { label: "Jhagadia", value: "Jhagadia" },
      { label: "Jhalod", value: "Jhalod" },
      { label: "Jodia", value: "Jodia" },
      { label: "Junagadh", value: "Junagadh" },
      { label: "Junagarh", value: "Junagarh" },
      { label: "Kalawad", value: "Kalawad" },
      { label: "Kalol", value: "Kalol" },
      { label: "Kapad Wanj", value: "Kapad Wanj" },
      { label: "Keshod", value: "Keshod" },
      { label: "Khambat", value: "Khambat" },
      { label: "Khambhalia", value: "Khambhalia" },
      { label: "Khavda", value: "Khavda" },
      { label: "Kheda", value: "Kheda" },
      { label: "Khedbrahma", value: "Khedbrahma" },
      { label: "Kheralu", value: "Kheralu" },
      { label: "Kodinar", value: "Kodinar" },
      { label: "Kotdasanghani", value: "Kotdasanghani" },
      { label: "Kunkawav", value: "Kunkawav" },
      { label: "Kutch", value: "Kutch" },
      { label: "Kutchmandvi", value: "Kutchmandvi" },
      { label: "Kutiyana", value: "Kutiyana" },
      { label: "Lakhpat", value: "Lakhpat" },
      { label: "Lakhtar", value: "Lakhtar" },
      { label: "Lalpur", value: "Lalpur" },
      { label: "Limbdi", value: "Limbdi" },
      { label: "Limkheda", value: "Limkheda" },
      { label: "Lunavada", value: "Lunavada" },
      { label: "M.M.Mangrol", value: "M.M.Mangrol" },
      { label: "Mahuva", value: "Mahuva" },
      { label: "Malia-Hatina", value: "Malia-Hatina" },
      { label: "Maliya", value: "Maliya" },
      { label: "Malpur", value: "Malpur" },
      { label: "Manavadar", value: "Manavadar" },
      { label: "Mandvi", value: "Mandvi" },
      { label: "Mangrol", value: "Mangrol" },
      { label: "Mehmedabad", value: "Mehmedabad" },
      { label: "Mehsana", value: "Mehsana" },
      { label: "Miyagam", value: "Miyagam" },
      { label: "Modasa", value: "Modasa" },
      { label: "Morvi", value: "Morvi" },
      { label: "Muli", value: "Muli" },
      { label: "Mundra", value: "Mundra" },
      { label: "Nadiad", value: "Nadiad" },
      { label: "Nakhatrana", value: "Nakhatrana" },
      { label: "Nalia", value: "Nalia" },
      { label: "Narmada", value: "Narmada" },
      { label: "Naswadi", value: "Naswadi" },
      { label: "Navasari", value: "Navasari" },
      { label: "Nizar", value: "Nizar" },
      { label: "Okha", value: "Okha" },
      { label: "Paddhari", value: "Paddhari" },
      { label: "Padra", value: "Padra" },
      { label: "Palanpur", value: "Palanpur" },
      { label: "Palitana", value: "Palitana" },
      { label: "Panchmahals", value: "Panchmahals" },
      { label: "Patan", value: "Patan" },
      { label: "Pavijetpur", value: "Pavijetpur" },
      { label: "Porbandar", value: "Porbandar" },
      { label: "Prantij", value: "Prantij" },
      { label: "Radhanpur", value: "Radhanpur" },
      { label: "Rahpar", value: "Rahpar" },
      { label: "Rajaula", value: "Rajaula" },
      { label: "Rajkot", value: "Rajkot" },
      { label: "Rajpipla", value: "Rajpipla" },
      { label: "Ranavav", value: "Ranavav" },
      { label: "Sabarkantha", value: "Sabarkantha" },
      { label: "Sanand", value: "Sanand" },
      { label: "Sankheda", value: "Sankheda" },
      { label: "Santalpur", value: "Santalpur" },
      { label: "Santrampur", value: "Santrampur" },
      { label: "Savarkundla", value: "Savarkundla" },
      { label: "Savli", value: "Savli" },
      { label: "Sayan", value: "Sayan" },
      { label: "Sayla", value: "Sayla" },
      { label: "Shehra", value: "Shehra" },
      { label: "Sidhpur", value: "Sidhpur" },
      { label: "Sihor", value: "Sihor" },
      { label: "Sojitra", value: "Sojitra" },
      { label: "Sumrasar", value: "Sumrasar" },
      { label: "Surat", value: "Surat" },
      { label: "Surendranagar", value: "Surendranagar" },
      { label: "Talaja", value: "Talaja" },
      { label: "Thara", value: "Thara" },
      { label: "Tharad", value: "Tharad" },
      { label: "Thasra", value: "Thasra" },
      { label: "Una-Diu", value: "Una-Diu" },
      { label: "Upleta", value: "Upleta" },
      { label: "Vadgam", value: "Vadgam" },
      { label: "Vadodara", value: "Vadodara" },
      { label: "Valia", value: "Valia" },
      { label: "Vallabhipur", value: "Vallabhipur" },
      { label: "Valod", value: "Valod" },
      { label: "Valsad", value: "Valsad" },
      { label: "Vanthali", value: "Vanthali" },
      { label: "Vapi", value: "Vapi" },
      { label: "Vav", value: "Vav" },
      { label: "Veraval", value: "Veraval" },
      { label: "Vijapur", value: "Vijapur" },
      { label: "Viramgam", value: "Viramgam" },
      { label: "Visavadar", value: "Visavadar" },
      { label: "Visnagar", value: "Visnagar" },
      { label: "Vyara", value: "Vyara" },
      { label: "Waghodia", value: "Waghodia" },
      { label: "Wankaner", value: "Wankaner" },
    ],
  },
  {
    label: "Haryana",
    title: "Haryana",
    options: [
      { label: "Adampur Mandi", value: "Adampur Mandi" },
      { label: "Ambala", value: "Ambala" },
      { label: "Assandh", value: "Assandh" },
      { label: "Bahadurgarh", value: "Bahadurgarh" },
      { label: "Barara", value: "Barara" },
      { label: "Barwala", value: "Barwala" },
      { label: "Bawal", value: "Bawal" },
      { label: "Bawanikhera", value: "Bawanikhera" },
      { label: "Bhiwani", value: "Bhiwani" },
      { label: "Charkhidadri", value: "Charkhidadri" },
      { label: "Cheeka", value: "Cheeka" },
      { label: "Chhachrauli", value: "Chhachrauli" },
      { label: "Dabwali", value: "Dabwali" },
      { label: "Ellenabad", value: "Ellenabad" },
      { label: "Faridabad", value: "Faridabad" },
      { label: "Fatehabad", value: "Fatehabad" },
      { label: "Ferojpur Jhirka", value: "Ferojpur Jhirka" },
      { label: "Gharaunda", value: "Gharaunda" },
      { label: "Gohana", value: "Gohana" },
      { label: "Gurgaon", value: "Gurgaon" },
      { label: "Hansi", value: "Hansi" },
      { label: "Hisar", value: "Hisar" },
      { label: "Jagadhari", value: "Jagadhari" },
      { label: "Jatusana", value: "Jatusana" },
      { label: "Jhajjar", value: "Jhajjar" },
      { label: "Jind", value: "Jind" },
      { label: "Julana", value: "Julana" },
      { label: "Kaithal", value: "Kaithal" },
      { label: "Kalanaur", value: "Kalanaur" },
      { label: "Kalanwali", value: "Kalanwali" },
      { label: "Kalka", value: "Kalka" },
      { label: "Karnal", value: "Karnal" },
      { label: "Kosli", value: "Kosli" },
      { label: "Kurukshetra", value: "Kurukshetra" },
      { label: "Loharu", value: "Loharu" },
      { label: "Mahendragarh", value: "Mahendragarh" },
      { label: "Meham", value: "Meham" },
      { label: "Mewat", value: "Mewat" },
      { label: "Mohindergarh", value: "Mohindergarh" },
      { label: "Naraingarh", value: "Naraingarh" },
      { label: "Narnaul", value: "Narnaul" },
      { label: "Narwana", value: "Narwana" },
      { label: "Nilokheri", value: "Nilokheri" },
      { label: "Nuh", value: "Nuh" },
      { label: "Palwal", value: "Palwal" },
      { label: "Panchkula", value: "Panchkula" },
      { label: "Panipat", value: "Panipat" },
      { label: "Pehowa", value: "Pehowa" },
      { label: "Ratia", value: "Ratia" },
      { label: "Rewari", value: "Rewari" },
      { label: "Rohtak", value: "Rohtak" },
      { label: "Safidon", value: "Safidon" },
      { label: "Sirsa", value: "Sirsa" },
      { label: "Siwani", value: "Siwani" },
      { label: "Sonipat", value: "Sonipat" },
      { label: "Tohana", value: "Tohana" },
      { label: "Tohsam", value: "Tohsam" },
      { label: "Yamunanagar", value: "Yamunanagar" },
    ],
  },
  {
    label: "Himachal Pradesh",
    title: "Himachal Pradesh",
    options: [
      { label: "Amb", value: "Amb" },
      { label: "Arki", value: "Arki" },
      { label: "Banjar", value: "Banjar" },
      { label: "Bharmour", value: "Bharmour" },
      { label: "Bilaspur", value: "Bilaspur" },
      { label: "Chamba", value: "Chamba" },
      { label: "Churah", value: "Churah" },
      { label: "Dalhousie", value: "Dalhousie" },
      { label: "Dehra Gopipur", value: "Dehra Gopipur" },
      { label: "Hamirpur", value: "Hamirpur" },
      { label: "Jogindernagar", value: "Jogindernagar" },
      { label: "Kalpa", value: "Kalpa" },
      { label: "Kangra", value: "Kangra" },
      { label: "Kinnaur", value: "Kinnaur" },
      { label: "Kullu", value: "Kullu" },
      { label: "Lahaul", value: "Lahaul" },
      { label: "Mandi", value: "Mandi" },
      { label: "Nahan", value: "Nahan" },
      { label: "Nalagarh", value: "Nalagarh" },
      { label: "Nirmand", value: "Nirmand" },
      { label: "Nurpur", value: "Nurpur" },
      { label: "Palampur", value: "Palampur" },
      { label: "Pangi", value: "Pangi" },
      { label: "Paonta", value: "Paonta" },
      { label: "Pooh", value: "Pooh" },
      { label: "Rajgarh", value: "Rajgarh" },
      { label: "Rampur Bushahar", value: "Rampur Bushahar" },
      { label: "Rohru", value: "Rohru" },
      { label: "Shimla", value: "Shimla" },
      { label: "Sirmaur", value: "Sirmaur" },
      { label: "Solan", value: "Solan" },
      { label: "Spiti", value: "Spiti" },
      { label: "Sundernagar", value: "Sundernagar" },
      { label: "Theog", value: "Theog" },
      { label: "Udaipur", value: "Udaipur" },
      { label: "Una", value: "Una" },
    ],
  },
  {
    label: "Jammu & Kashmir",
    title: "Jammu & Kashmir",
    options: [
      { label: "Akhnoor", value: "Akhnoor" },
      { label: "Anantnag", value: "Anantnag" },
      { label: "Badgam", value: "Badgam" },
      { label: "Bandipur", value: "Bandipur" },
      { label: "Baramulla", value: "Baramulla" },
      { label: "Basholi", value: "Basholi" },
      { label: "Bedarwah", value: "Bedarwah" },
      { label: "Budgam", value: "Budgam" },
      { label: "Doda", value: "Doda" },
      { label: "Gulmarg", value: "Gulmarg" },
      { label: "Jammu", value: "Jammu" },
      { label: "Kalakot", value: "Kalakot" },
      { label: "Kargil", value: "Kargil" },
      { label: "Karnah", value: "Karnah" },
      { label: "Kathua", value: "Kathua" },
      { label: "Kishtwar", value: "Kishtwar" },
      { label: "Kulgam", value: "Kulgam" },
      { label: "Kupwara", value: "Kupwara" },
      { label: "Leh", value: "Leh" },
      { label: "Mahore", value: "Mahore" },
      { label: "Nagrota", value: "Nagrota" },
      { label: "Nobra", value: "Nobra" },
      { label: "Nowshera", value: "Nowshera" },
      { label: "Nyoma", value: "Nyoma" },
      { label: "Padam", value: "Padam" },
      { label: "Pahalgam", value: "Pahalgam" },
      { label: "Patnitop", value: "Patnitop" },
      { label: "Poonch", value: "Poonch" },
      { label: "Pulwama", value: "Pulwama" },
      { label: "Rajouri", value: "Rajouri" },
      { label: "Ramban", value: "Ramban" },
      { label: "Ramnagar", value: "Ramnagar" },
      { label: "Reasi", value: "Reasi" },
      { label: "Samba", value: "Samba" },
      { label: "Srinagar", value: "Srinagar" },
      { label: "Udhampur", value: "Udhampur" },
      { label: "Vaishno Devi", value: "Vaishno Devi" },
    ],
  },
  {
    label: "Jharkhand",
    title: "Jharkhand",
    options: [
      { label: "Bagodar", value: "Bagodar" },
      { label: "Baharagora", value: "Baharagora" },
      { label: "Balumath", value: "Balumath" },
      { label: "Barhi", value: "Barhi" },
      { label: "Barkagaon", value: "Barkagaon" },
      { label: "Barwadih", value: "Barwadih" },
      { label: "Basia", value: "Basia" },
      { label: "Bermo", value: "Bermo" },
      { label: "Bhandaria", value: "Bhandaria" },
      { label: "Bhawanathpur", value: "Bhawanathpur" },
      { label: "Bishrampur", value: "Bishrampur" },
      { label: "Bokaro", value: "Bokaro" },
      { label: "Bolwa", value: "Bolwa" },
      { label: "Bundu", value: "Bundu" },
      { label: "Chaibasa", value: "Chaibasa" },
      { label: "Chainpur", value: "Chainpur" },
      { label: "Chakardharpur", value: "Chakardharpur" },
      { label: "Chandil", value: "Chandil" },
      { label: "Chatra", value: "Chatra" },
      { label: "Chavparan", value: "Chavparan" },
      { label: "Daltonganj", value: "Daltonganj" },
      { label: "Deoghar", value: "Deoghar" },
      { label: "Dhanbad", value: "Dhanbad" },
      { label: "Dumka", value: "Dumka" },
      { label: "Dumri", value: "Dumri" },
      { label: "Garhwa", value: "Garhwa" },
      { label: "Garu", value: "Garu" },
      { label: "Ghaghra", value: "Ghaghra" },
      { label: "Ghatsila", value: "Ghatsila" },
      { label: "Giridih", value: "Giridih" },
      { label: "Godda", value: "Godda" },
      { label: "Gomia", value: "Gomia" },
      { label: "Govindpur", value: "Govindpur" },
      { label: "Gumla", value: "Gumla" },
      { label: "Hazaribagh", value: "Hazaribagh" },
      { label: "Hunterganj", value: "Hunterganj" },
      { label: "Ichak", value: "Ichak" },
      { label: "Itki", value: "Itki" },
      { label: "Jagarnathpur", value: "Jagarnathpur" },
      { label: "Jamshedpur", value: "Jamshedpur" },
      { label: "Jamtara", value: "Jamtara" },
      { label: "Japla", value: "Japla" },
      { label: "Jharmundi", value: "Jharmundi" },
      { label: "Jhinkpani", value: "Jhinkpani" },
      { label: "Jhumaritalaiya", value: "Jhumaritalaiya" },
      { label: "Kathikund", value: "Kathikund" },
      { label: "Kharsawa", value: "Kharsawa" },
      { label: "Khunti", value: "Khunti" },
      { label: "Koderma", value: "Koderma" },
      { label: "Kolebira", value: "Kolebira" },
      { label: "Latehar", value: "Latehar" },
      { label: "Lohardaga", value: "Lohardaga" },
      { label: "Madhupur", value: "Madhupur" },
      { label: "Mahagama", value: "Mahagama" },
      { label: "Maheshpur Raj", value: "Maheshpur Raj" },
      { label: "Mandar", value: "Mandar" },
      { label: "Mandu", value: "Mandu" },
      { label: "Manoharpur", value: "Manoharpur" },
      { label: "Muri", value: "Muri" },
      { label: "Nagarutatri", value: "Nagarutatri" },
      { label: "Nala", value: "Nala" },
      { label: "Noamundi", value: "Noamundi" },
      { label: "Pakur", value: "Pakur" },
      { label: "Palamu", value: "Palamu" },
      { label: "Palkot", value: "Palkot" },
      { label: "Patan", value: "Patan" },
      { label: "Rajdhanwar", value: "Rajdhanwar" },
      { label: "Rajmahal", value: "Rajmahal" },
      { label: "Ramgarh", value: "Ramgarh" },
      { label: "Ranchi", value: "Ranchi" },
      { label: "Sahibganj", value: "Sahibganj" },
      { label: "Saraikela", value: "Saraikela" },
      { label: "Simaria", value: "Simaria" },
      { label: "Simdega", value: "Simdega" },
      { label: "Singhbhum", value: "Singhbhum" },
      { label: "Tisri", value: "Tisri" },
      { label: "Torpa", value: "Torpa" },
    ],
  },
  {
    label: "Karnataka",
    title: "Karnataka",
    options: [
      { label: "Afzalpur", value: "Afzalpur" },
      { label: "Ainapur", value: "Ainapur" },
      { label: "Aland", value: "Aland" },
      { label: "Alur", value: "Alur" },
      { label: "Anekal", value: "Anekal" },
      { label: "Ankola", value: "Ankola" },
      { label: "Arsikere", value: "Arsikere" },
      { label: "Athani", value: "Athani" },
      { label: "Aurad", value: "Aurad" },
      { label: "Bableshwar", value: "Bableshwar" },
      { label: "Badami", value: "Badami" },
      { label: "Bagalkot", value: "Bagalkot" },
      { label: "Bagepalli", value: "Bagepalli" },
      { label: "Bailhongal", value: "Bailhongal" },
      { label: "Bangalore", value: "Bangalore" },
      { label: "Bangalore Rural", value: "Bangalore Rural" },
      { label: "Bangarpet", value: "Bangarpet" },
      { label: "Bantwal", value: "Bantwal" },
      { label: "Basavakalyan", value: "Basavakalyan" },
      { label: "Basavanabagewadi", value: "Basavanabagewadi" },
      { label: "Basavapatna", value: "Basavapatna" },
      { label: "Belgaum", value: "Belgaum" },
      { label: "Bellary", value: "Bellary" },
      { label: "Belthangady", value: "Belthangady" },
      { label: "Belur", value: "Belur" },
      { label: "Bhadravati", value: "Bhadravati" },
      { label: "Bhalki", value: "Bhalki" },
      { label: "Bhatkal", value: "Bhatkal" },
      { label: "Bidar", value: "Bidar" },
      { label: "Bijapur", value: "Bijapur" },
      { label: "Biligi", value: "Biligi" },
      { label: "Chadchan", value: "Chadchan" },
      { label: "Challakere", value: "Challakere" },
      { label: "Chamrajnagar", value: "Chamrajnagar" },
      { label: "Channagiri", value: "Channagiri" },
      { label: "Channapatna", value: "Channapatna" },
      { label: "Channarayapatna", value: "Channarayapatna" },
      { label: "Chickmagalur", value: "Chickmagalur" },
      { label: "Chikballapur", value: "Chikballapur" },
      { label: "Chikkaballapur", value: "Chikkaballapur" },
      { label: "Chikkanayakanahalli", value: "Chikkanayakanahalli" },
      { label: "Chikkodi", value: "Chikkodi" },
      { label: "Chikmagalur", value: "Chikmagalur" },
      { label: "Chincholi", value: "Chincholi" },
      { label: "Chintamani", value: "Chintamani" },
      { label: "Chitradurga", value: "Chitradurga" },
      { label: "Chittapur", value: "Chittapur" },
      { label: "Cowdahalli", value: "Cowdahalli" },
      { label: "Davanagere", value: "Davanagere" },
      { label: "Deodurga", value: "Deodurga" },
      { label: "Devangere", value: "Devangere" },
      { label: "Devarahippargi", value: "Devarahippargi" },
      { label: "Dharwad", value: "Dharwad" },
      { label: "Doddaballapur", value: "Doddaballapur" },
      { label: "Gadag", value: "Gadag" },
      { label: "Gangavathi", value: "Gangavathi" },
      { label: "Gokak", value: "Gokak" },
      { label: "Gowribdanpur", value: "Gowribdanpur" },
      { label: "Gubbi", value: "Gubbi" },
      { label: "Gulbarga", value: "Gulbarga" },
      { label: "Gundlupet", value: "Gundlupet" },
      { label: "H.B.Halli", value: "H.B.Halli" },
      { label: "H.D. Kote", value: "H.D. Kote" },
      { label: "Haliyal", value: "Haliyal" },
      { label: "Hampi", value: "Hampi" },
      { label: "Hangal", value: "Hangal" },
      { label: "Harapanahalli", value: "Harapanahalli" },
      { label: "Hassan", value: "Hassan" },
      { label: "Haveri", value: "Haveri" },
      { label: "Hebri", value: "Hebri" },
      { label: "Hirekerur", value: "Hirekerur" },
      { label: "Hiriyur", value: "Hiriyur" },
      { label: "Holalkere", value: "Holalkere" },
      { label: "Holenarsipur", value: "Holenarsipur" },
      { label: "Honnali", value: "Honnali" },
      { label: "Honnavar", value: "Honnavar" },
      { label: "Hosadurga", value: "Hosadurga" },
      { label: "Hosakote", value: "Hosakote" },
      { label: "Hosanagara", value: "Hosanagara" },
      { label: "Hospet", value: "Hospet" },
      { label: "Hubli", value: "Hubli" },
      { label: "Hukkeri", value: "Hukkeri" },
      { label: "Humnabad", value: "Humnabad" },
      { label: "Hungund", value: "Hungund" },
      { label: "Hunsagi", value: "Hunsagi" },
      { label: "Hunsur", value: "Hunsur" },
      { label: "Huvinahadagali", value: "Huvinahadagali" },
      { label: "Indi", value: "Indi" },
      { label: "Jagalur", value: "Jagalur" },
      { label: "Jamkhandi", value: "Jamkhandi" },
      { label: "Jewargi", value: "Jewargi" },
      { label: "Joida", value: "Joida" },
      { label: "K.R. Nagar", value: "K.R. Nagar" },
      { label: "Kadur", value: "Kadur" },
      { label: "Kalghatagi", value: "Kalghatagi" },
      { label: "Kamalapur", value: "Kamalapur" },
      { label: "Kanakapura", value: "Kanakapura" },
      { label: "Kannada", value: "Kannada" },
      { label: "Kargal", value: "Kargal" },
      { label: "Karkala", value: "Karkala" },
      { label: "Karwar", value: "Karwar" },
      { label: "Khanapur", value: "Khanapur" },
      { label: "Kodagu", value: "Kodagu" },
      { label: "Kolar", value: "Kolar" },
      { label: "Kollegal", value: "Kollegal" },
      { label: "Koppa", value: "Koppa" },
      { label: "Koppal", value: "Koppal" },
      { label: "Koratageri", value: "Koratageri" },
      { label: "Krishnarajapet", value: "Krishnarajapet" },
      { label: "Kudligi", value: "Kudligi" },
      { label: "Kumta", value: "Kumta" },
      { label: "Kundapur", value: "Kundapur" },
      { label: "Kundgol", value: "Kundgol" },
      { label: "Kunigal", value: "Kunigal" },
      { label: "Kurugodu", value: "Kurugodu" },
      { label: "Kustagi", value: "Kustagi" },
      { label: "Lingsugur", value: "Lingsugur" },
      { label: "Madikeri", value: "Madikeri" },
      { label: "Madugiri", value: "Madugiri" },
      { label: "Malavalli", value: "Malavalli" },
      { label: "Malur", value: "Malur" },
      { label: "Mandya", value: "Mandya" },
      { label: "Mangalore", value: "Mangalore" },
      { label: "Manipal", value: "Manipal" },
      { label: "Manvi", value: "Manvi" },
      { label: "Mashal", value: "Mashal" },
      { label: "Molkalmuru", value: "Molkalmuru" },
      { label: "Mudalgi", value: "Mudalgi" },
      { label: "Muddebihal", value: "Muddebihal" },
      { label: "Mudhol", value: "Mudhol" },
      { label: "Mudigere", value: "Mudigere" },
      { label: "Mulbagal", value: "Mulbagal" },
      { label: "Mundagod", value: "Mundagod" },
      { label: "Mundargi", value: "Mundargi" },
      { label: "Murugod", value: "Murugod" },
      { label: "Mysore", value: "Mysore" },
      { label: "Nagamangala", value: "Nagamangala" },
      { label: "Nanjangud", value: "Nanjangud" },
      { label: "Nargund", value: "Nargund" },
      { label: "Narsimrajapur", value: "Narsimrajapur" },
      { label: "Navalgund", value: "Navalgund" },
      { label: "Nelamangala", value: "Nelamangala" },
      { label: "Nimburga", value: "Nimburga" },
      { label: "Pandavapura", value: "Pandavapura" },
      { label: "Pavagada", value: "Pavagada" },
      { label: "Puttur", value: "Puttur" },
      { label: "Raibag", value: "Raibag" },
      { label: "Raichur", value: "Raichur" },
      { label: "Ramdurg", value: "Ramdurg" },
      { label: "Ranebennur", value: "Ranebennur" },
      { label: "Ron", value: "Ron" },
      { label: "Sagar", value: "Sagar" },
      { label: "Sakleshpur", value: "Sakleshpur" },
      { label: "Salkani", value: "Salkani" },
      { label: "Sandur", value: "Sandur" },
      { label: "Saundatti", value: "Saundatti" },
      { label: "Savanur", value: "Savanur" },
      { label: "Sedam", value: "Sedam" },
      { label: "Shahapur", value: "Shahapur" },
      { label: "Shankarnarayana", value: "Shankarnarayana" },
      { label: "Shikaripura", value: "Shikaripura" },
      { label: "Shimoga", value: "Shimoga" },
      { label: "Shirahatti", value: "Shirahatti" },
      { label: "Shorapur", value: "Shorapur" },
      { label: "Siddapur", value: "Siddapur" },
      { label: "Sidlaghatta", value: "Sidlaghatta" },
      { label: "Sindagi", value: "Sindagi" },
      { label: "Sindhanur", value: "Sindhanur" },
      { label: "Sira", value: "Sira" },
      { label: "Sirsi", value: "Sirsi" },
      { label: "Siruguppa", value: "Siruguppa" },
      { label: "Somwarpet", value: "Somwarpet" },
      { label: "Sorab", value: "Sorab" },
      { label: "Sringeri", value: "Sringeri" },
      { label: "Sriniwaspur", value: "Sriniwaspur" },
      { label: "Srirangapatna", value: "Srirangapatna" },
      { label: "Sullia", value: "Sullia" },
      { label: "T. Narsipur", value: "T. Narsipur" },
      { label: "Tallak", value: "Tallak" },
      { label: "Tarikere", value: "Tarikere" },
      { label: "Telgi", value: "Telgi" },
      { label: "Thirthahalli", value: "Thirthahalli" },
      { label: "Tiptur", value: "Tiptur" },
      { label: "Tumkur", value: "Tumkur" },
      { label: "Turuvekere", value: "Turuvekere" },
      { label: "Udupi", value: "Udupi" },
      { label: "Virajpet", value: "Virajpet" },
      { label: "Wadi", value: "Wadi" },
      { label: "Yadgiri", value: "Yadgiri" },
      { label: "Yelburga", value: "Yelburga" },
      { label: "Yellapur", value: "Yellapur" },
    ],
  },
  {
    label: "Kerala",
    title: "Kerala",
    options: [
      { label: "Adimaly", value: "Adimaly" },
      { label: "Adoor", value: "Adoor" },
      { label: "Agathy", value: "Agathy" },
      { label: "Alappuzha", value: "Alappuzha" },
      { label: "Alathur", value: "Alathur" },
      { label: "Alleppey", value: "Alleppey" },
      { label: "Alwaye", value: "Alwaye" },
      { label: "Amini", value: "Amini" },
      { label: "Androth", value: "Androth" },
      { label: "Attingal", value: "Attingal" },
      { label: "Badagara", value: "Badagara" },
      { label: "Bitra", value: "Bitra" },
      { label: "Calicut", value: "Calicut" },
      { label: "Cannanore", value: "Cannanore" },
      { label: "Chetlet", value: "Chetlet" },
      { label: "Ernakulam", value: "Ernakulam" },
      { label: "Idukki", value: "Idukki" },
      { label: "Irinjalakuda", value: "Irinjalakuda" },
      { label: "Kadamath", value: "Kadamath" },
      { label: "Kalpeni", value: "Kalpeni" },
      { label: "Kalpetta", value: "Kalpetta" },
      { label: "Kanhangad", value: "Kanhangad" },
      { label: "Kanjirapally", value: "Kanjirapally" },
      { label: "Kannur", value: "Kannur" },
      { label: "Karungapally", value: "Karungapally" },
      { label: "Kasargode", value: "Kasargode" },
      { label: "Kavarathy", value: "Kavarathy" },
      { label: "Kiltan", value: "Kiltan" },
      { label: "Kochi", value: "Kochi" },
      { label: "Koduvayur", value: "Koduvayur" },
      { label: "Kollam", value: "Kollam" },
      { label: "Kottayam", value: "Kottayam" },
      { label: "Kovalam", value: "Kovalam" },
      { label: "Kozhikode", value: "Kozhikode" },
      { label: "Kunnamkulam", value: "Kunnamkulam" },
      { label: "Malappuram", value: "Malappuram" },
      { label: "Mananthodi", value: "Mananthodi" },
      { label: "Manjeri", value: "Manjeri" },
      { label: "Mannarghat", value: "Mannarghat" },
      { label: "Mavelikkara", value: "Mavelikkara" },
      { label: "Minicoy", value: "Minicoy" },
      { label: "Munnar", value: "Munnar" },
      { label: "Muvattupuzha", value: "Muvattupuzha" },
      { label: "Nedumandad", value: "Nedumandad" },
      { label: "Nedumgandam", value: "Nedumgandam" },
      { label: "Nilambur", value: "Nilambur" },
      { label: "Palai", value: "Palai" },
      { label: "Palakkad", value: "Palakkad" },
      { label: "Palghat", value: "Palghat" },
      { label: "Pathaanamthitta", value: "Pathaanamthitta" },
      { label: "Pathanamthitta", value: "Pathanamthitta" },
      { label: "Payyanur", value: "Payyanur" },
      { label: "Peermedu", value: "Peermedu" },
      { label: "Perinthalmanna", value: "Perinthalmanna" },
      { label: "Perumbavoor", value: "Perumbavoor" },
      { label: "Punalur", value: "Punalur" },
      { label: "Quilon", value: "Quilon" },
      { label: "Ranni", value: "Ranni" },
      { label: "Shertallai", value: "Shertallai" },
      { label: "Shoranur", value: "Shoranur" },
      { label: "Taliparamba", value: "Taliparamba" },
      { label: "Tellicherry", value: "Tellicherry" },
      { label: "Thiruvananthapuram", value: "Thiruvananthapuram" },
      { label: "Thodupuzha", value: "Thodupuzha" },
      { label: "Thrissur", value: "Thrissur" },
      { label: "Tirur", value: "Tirur" },
      { label: "Tiruvalla", value: "Tiruvalla" },
      { label: "Trichur", value: "Trichur" },
      { label: "Trivandrum", value: "Trivandrum" },
      { label: "Uppala", value: "Uppala" },
      { label: "Vadakkanchery", value: "Vadakkanchery" },
      { label: "Vikom", value: "Vikom" },
      { label: "Wayanad", value: "Wayanad" },
    ],
  },
  {
    label: "Lakshadweep",
    title: "Lakshadweep",
    options: [
      { label: "Agatti Island", value: "Agatti Island" },
      { label: "Bingaram Island", value: "Bingaram Island" },
      { label: "Bitra Island", value: "Bitra Island" },
      { label: "Chetlat Island", value: "Chetlat Island" },
      { label: "Kadmat Island", value: "Kadmat Island" },
      { label: "Kalpeni Island", value: "Kalpeni Island" },
      { label: "Kavaratti Island", value: "Kavaratti Island" },
      { label: "Kiltan Island", value: "Kiltan Island" },
      { label: "Lakshadweep Sea", value: "Lakshadweep Sea" },
      { label: "Minicoy Island", value: "Minicoy Island" },
      { label: "North Island", value: "North Island" },
      { label: "South Island", value: "South Island" },
    ],
  },
  {
    label: "Madhya Pradesh",
    title: "Madhya Pradesh",
    options: [
      { label: "Agar", value: "Agar" },
      { label: "Ajaigarh", value: "Ajaigarh" },
      { label: "Alirajpur", value: "Alirajpur" },
      { label: "Amarpatan", value: "Amarpatan" },
      { label: "Amarwada", value: "Amarwada" },
      { label: "Ambah", value: "Ambah" },
      { label: "Anuppur", value: "Anuppur" },
      { label: "Arone", value: "Arone" },
      { label: "Ashoknagar", value: "Ashoknagar" },
      { label: "Ashta", value: "Ashta" },
      { label: "Atner", value: "Atner" },
      { label: "Babaichichli", value: "Babaichichli" },
      { label: "Badamalhera", value: "Badamalhera" },
      { label: "Badarwsas", value: "Badarwsas" },
      { label: "Badnagar", value: "Badnagar" },
      { label: "Badnawar", value: "Badnawar" },
      { label: "Badwani", value: "Badwani" },
      { label: "Bagli", value: "Bagli" },
      { label: "Baihar", value: "Baihar" },
      { label: "Balaghat", value: "Balaghat" },
      { label: "Baldeogarh", value: "Baldeogarh" },
      { label: "Baldi", value: "Baldi" },
      { label: "Bamori", value: "Bamori" },
      { label: "Banda", value: "Banda" },
      { label: "Bandhavgarh", value: "Bandhavgarh" },
      { label: "Bareli", value: "Bareli" },
      { label: "Baroda", value: "Baroda" },
      { label: "Barwaha", value: "Barwaha" },
      { label: "Barwani", value: "Barwani" },
      { label: "Batkakhapa", value: "Batkakhapa" },
      { label: "Begamganj", value: "Begamganj" },
      { label: "Beohari", value: "Beohari" },
      { label: "Berasia", value: "Berasia" },
      { label: "Berchha", value: "Berchha" },
      { label: "Betul", value: "Betul" },
      { label: "Bhainsdehi", value: "Bhainsdehi" },
      { label: "Bhander", value: "Bhander" },
      { label: "Bhanpura", value: "Bhanpura" },
      { label: "Bhikangaon", value: "Bhikangaon" },
      { label: "Bhimpur", value: "Bhimpur" },
      { label: "Bhind", value: "Bhind" },
      { label: "Bhitarwar", value: "Bhitarwar" },
      { label: "Bhopal", value: "Bhopal" },
      { label: "Biaora", value: "Biaora" },
      { label: "Bijadandi", value: "Bijadandi" },
      { label: "Bijawar", value: "Bijawar" },
      { label: "Bijaypur", value: "Bijaypur" },
      { label: "Bina", value: "Bina" },
      { label: "Birsa", value: "Birsa" },
      { label: "Birsinghpur", value: "Birsinghpur" },
      { label: "Budhni", value: "Budhni" },
      { label: "Burhanpur", value: "Burhanpur" },
      { label: "Buxwaha", value: "Buxwaha" },
      { label: "Chachaura", value: "Chachaura" },
      { label: "Chanderi", value: "Chanderi" },
      { label: "Chaurai", value: "Chaurai" },
      { label: "Chhapara", value: "Chhapara" },
      { label: "Chhatarpur", value: "Chhatarpur" },
      { label: "Chhindwara", value: "Chhindwara" },
      { label: "Chicholi", value: "Chicholi" },
      { label: "Chitrangi", value: "Chitrangi" },
      { label: "Churhat", value: "Churhat" },
      { label: "Dabra", value: "Dabra" },
      { label: "Damoh", value: "Damoh" },
      { label: "Datia", value: "Datia" },
      { label: "Deori", value: "Deori" },
      { label: "Deosar", value: "Deosar" },
      { label: "Depalpur", value: "Depalpur" },
      { label: "Dewas", value: "Dewas" },
      { label: "Dhar", value: "Dhar" },
      { label: "Dharampuri", value: "Dharampuri" },
      { label: "Dindori", value: "Dindori" },
      { label: "Gadarwara", value: "Gadarwara" },
      { label: "Gairatganj", value: "Gairatganj" },
      { label: "Ganjbasoda", value: "Ganjbasoda" },
      { label: "Garoth", value: "Garoth" },
      { label: "Ghansour", value: "Ghansour" },
      { label: "Ghatia", value: "Ghatia" },
      { label: "Ghatigaon", value: "Ghatigaon" },
      { label: "Ghorandogri", value: "Ghorandogri" },
      { label: "Ghughari", value: "Ghughari" },
      { label: "Gogaon", value: "Gogaon" },
      { label: "Gohad", value: "Gohad" },
      { label: "Goharganj", value: "Goharganj" },
      { label: "Gopalganj", value: "Gopalganj" },
      { label: "Gotegaon", value: "Gotegaon" },
      { label: "Gourihar", value: "Gourihar" },
      { label: "Guna", value: "Guna" },
      { label: "Gunnore", value: "Gunnore" },
      { label: "Gwalior", value: "Gwalior" },
      { label: "Gyraspur", value: "Gyraspur" },
      { label: "Hanumana", value: "Hanumana" },
      { label: "Harda", value: "Harda" },
      { label: "Harrai", value: "Harrai" },
      { label: "Harsud", value: "Harsud" },
      { label: "Hatta", value: "Hatta" },
      { label: "Hoshangabad", value: "Hoshangabad" },
      { label: "Ichhawar", value: "Ichhawar" },
      { label: "Indore", value: "Indore" },
      { label: "Isagarh", value: "Isagarh" },
      { label: "Itarsi", value: "Itarsi" },
      { label: "Jabalpur", value: "Jabalpur" },
      { label: "Jabera", value: "Jabera" },
      { label: "Jagdalpur", value: "Jagdalpur" },
      { label: "Jaisinghnagar", value: "Jaisinghnagar" },
      { label: "Jaithari", value: "Jaithari" },
      { label: "Jaitpur", value: "Jaitpur" },
      { label: "Jaitwara", value: "Jaitwara" },
      { label: "Jamai", value: "Jamai" },
      { label: "Jaora", value: "Jaora" },
      { label: "Jatara", value: "Jatara" },
      { label: "Jawad", value: "Jawad" },
      { label: "Jhabua", value: "Jhabua" },
      { label: "Jobat", value: "Jobat" },
      { label: "Jora", value: "Jora" },
      { label: "Kakaiya", value: "Kakaiya" },
      { label: "Kannod", value: "Kannod" },
      { label: "Kannodi", value: "Kannodi" },
      { label: "Karanjia", value: "Karanjia" },
      { label: "Kareli", value: "Kareli" },
      { label: "Karera", value: "Karera" },
      { label: "Karhal", value: "Karhal" },
      { label: "Karpa", value: "Karpa" },
      { label: "Kasrawad", value: "Kasrawad" },
      { label: "Katangi", value: "Katangi" },
      { label: "Katni", value: "Katni" },
      { label: "Keolari", value: "Keolari" },
      { label: "Khachrod", value: "Khachrod" },
      { label: "Khajuraho", value: "Khajuraho" },
      { label: "Khakner", value: "Khakner" },
      { label: "Khalwa", value: "Khalwa" },
      { label: "Khandwa", value: "Khandwa" },
      { label: "Khaniadhana", value: "Khaniadhana" },
      { label: "Khargone", value: "Khargone" },
      { label: "Khategaon", value: "Khategaon" },
      { label: "Khetia", value: "Khetia" },
      { label: "Khilchipur", value: "Khilchipur" },
      { label: "Khirkiya", value: "Khirkiya" },
      { label: "Khurai", value: "Khurai" },
      { label: "Kolaras", value: "Kolaras" },
      { label: "Kotma", value: "Kotma" },
      { label: "Kukshi", value: "Kukshi" },
      { label: "Kundam", value: "Kundam" },
      { label: "Kurwai", value: "Kurwai" },
      { label: "Kusmi", value: "Kusmi" },
      { label: "Laher", value: "Laher" },
      { label: "Lakhnadon", value: "Lakhnadon" },
      { label: "Lamta", value: "Lamta" },
      { label: "Lanji", value: "Lanji" },
      { label: "Lateri", value: "Lateri" },
      { label: "Laundi", value: "Laundi" },
      { label: "Maheshwar", value: "Maheshwar" },
      { label: "Mahidpurcity", value: "Mahidpurcity" },
      { label: "Maihar", value: "Maihar" },
      { label: "Majhagwan", value: "Majhagwan" },
      { label: "Majholi", value: "Majholi" },
      { label: "Malhargarh", value: "Malhargarh" },
      { label: "Manasa", value: "Manasa" },
      { label: "Manawar", value: "Manawar" },
      { label: "Mandla", value: "Mandla" },
      { label: "Mandsaur", value: "Mandsaur" },
      { label: "Manpur", value: "Manpur" },
      { label: "Mauganj", value: "Mauganj" },
      { label: "Mawai", value: "Mawai" },
      { label: "Mehgaon", value: "Mehgaon" },
      { label: "Mhow", value: "Mhow" },
      { label: "Morena", value: "Morena" },
      { label: "Multai", value: "Multai" },
      { label: "Mungaoli", value: "Mungaoli" },
      { label: "Nagod", value: "Nagod" },
      { label: "Nainpur", value: "Nainpur" },
      { label: "Narsingarh", value: "Narsingarh" },
      { label: "Narsinghpur", value: "Narsinghpur" },
      { label: "Narwar", value: "Narwar" },
      { label: "Nasrullaganj", value: "Nasrullaganj" },
      { label: "Nateran", value: "Nateran" },
      { label: "Neemuch", value: "Neemuch" },
      { label: "Niwari", value: "Niwari" },
      { label: "Niwas", value: "Niwas" },
      { label: "Nowgaon", value: "Nowgaon" },
      { label: "Pachmarhi", value: "Pachmarhi" },
      { label: "Pandhana", value: "Pandhana" },
      { label: "Pandhurna", value: "Pandhurna" },
      { label: "Panna", value: "Panna" },
      { label: "Parasia", value: "Parasia" },
      { label: "Patan", value: "Patan" },
      { label: "Patera", value: "Patera" },
      { label: "Patharia", value: "Patharia" },
      { label: "Pawai", value: "Pawai" },
      { label: "Petlawad", value: "Petlawad" },
      { label: "Pichhore", value: "Pichhore" },
      { label: "Piparia", value: "Piparia" },
      { label: "Pohari", value: "Pohari" },
      { label: "Prabhapattan", value: "Prabhapattan" },
      { label: "Punasa", value: "Punasa" },
      { label: "Pushprajgarh", value: "Pushprajgarh" },
      { label: "Raghogarh", value: "Raghogarh" },
      { label: "Raghunathpur", value: "Raghunathpur" },
      { label: "Rahatgarh", value: "Rahatgarh" },
      { label: "Raisen", value: "Raisen" },
      { label: "Rajgarh", value: "Rajgarh" },
      { label: "Rajpur", value: "Rajpur" },
      { label: "Ratlam", value: "Ratlam" },
      { label: "Rehli", value: "Rehli" },
      { label: "Rewa", value: "Rewa" },
      { label: "Sabalgarh", value: "Sabalgarh" },
      { label: "Sagar", value: "Sagar" },
      { label: "Sailana", value: "Sailana" },
      { label: "Sanwer", value: "Sanwer" },
      { label: "Sarangpur", value: "Sarangpur" },
      { label: "Sardarpur", value: "Sardarpur" },
      { label: "Satna", value: "Satna" },
      { label: "Saunsar", value: "Saunsar" },
      { label: "Sehore", value: "Sehore" },
      { label: "Sendhwa", value: "Sendhwa" },
      { label: "Seondha", value: "Seondha" },
      { label: "Seoni", value: "Seoni" },
      { label: "Seonimalwa", value: "Seonimalwa" },
      { label: "Shahdol", value: "Shahdol" },
      { label: "Shahnagar", value: "Shahnagar" },
      { label: "Shahpur", value: "Shahpur" },
      { label: "Shajapur", value: "Shajapur" },
      { label: "Sheopur", value: "Sheopur" },
      { label: "Sheopurkalan", value: "Sheopurkalan" },
      { label: "Shivpuri", value: "Shivpuri" },
      { label: "Shujalpur", value: "Shujalpur" },
      { label: "Sidhi", value: "Sidhi" },
      { label: "Sihora", value: "Sihora" },
      { label: "Silwani", value: "Silwani" },
      { label: "Singrauli", value: "Singrauli" },
      { label: "Sirmour", value: "Sirmour" },
      { label: "Sironj", value: "Sironj" },
      { label: "Sitamau", value: "Sitamau" },
      { label: "Sohagpur", value: "Sohagpur" },
      { label: "Sondhwa", value: "Sondhwa" },
      { label: "Sonkatch", value: "Sonkatch" },
      { label: "Susner", value: "Susner" },
      { label: "Tamia", value: "Tamia" },
      { label: "Tarana", value: "Tarana" },
      { label: "Tendukheda", value: "Tendukheda" },
      { label: "Teonthar", value: "Teonthar" },
      { label: "Thandla", value: "Thandla" },
      { label: "Tikamgarh", value: "Tikamgarh" },
      { label: "Timarani", value: "Timarani" },
      { label: "Udaipura", value: "Udaipura" },
      { label: "Ujjain", value: "Ujjain" },
      { label: "Umaria", value: "Umaria" },
      { label: "Umariapan", value: "Umariapan" },
      { label: "Vidisha", value: "Vidisha" },
      { label: "Vijayraghogarh", value: "Vijayraghogarh" },
      { label: "Waraseoni", value: "Waraseoni" },
      { label: "Zhirnia", value: "Zhirnia" },
    ],
  },
  {
    label: "Maharashtra",
    title: "Maharashtra",
    options: [
      { label: "Achalpur", value: "Achalpur" },
      { label: "Aheri", value: "Aheri" },
      { label: "Ahmednagar", value: "Ahmednagar" },
      { label: "Ahmedpur", value: "Ahmedpur" },
      { label: "Ajara", value: "Ajara" },
      { label: "Akkalkot", value: "Akkalkot" },
      { label: "Akola", value: "Akola" },
      { label: "Akole", value: "Akole" },
      { label: "Akot", value: "Akot" },
      { label: "Alibagh", value: "Alibagh" },
      { label: "Amagaon", value: "Amagaon" },
      { label: "Amalner", value: "Amalner" },
      { label: "Ambad", value: "Ambad" },
      { label: "Ambejogai", value: "Ambejogai" },
      { label: "Amravati", value: "Amravati" },
      { label: "Arjuni Merogaon", value: "Arjuni Merogaon" },
      { label: "Arvi", value: "Arvi" },
      { label: "Ashti", value: "Ashti" },
      { label: "Atpadi", value: "Atpadi" },
      { label: "Ausa", value: "Ausa" },
      { label: "Babhulgaon", value: "Babhulgaon" },
      { label: "Balapur", value: "Balapur" },
      { label: "Baramati", value: "Baramati" },
      { label: "Barshi Takli", value: "Barshi Takli" },
      { label: "Barsi", value: "Barsi" },
      { label: "Basmatnagar", value: "Basmatnagar" },
      { label: "Bassein", value: "Bassein" },
      { label: "Beed", value: "Beed" },
      { label: "Bhadrawati", value: "Bhadrawati" },
      { label: "Bhamregadh", value: "Bhamregadh" },
      { label: "Bhandara", value: "Bhandara" },
      { label: "Bhir", value: "Bhir" },
      { label: "Bhiwandi", value: "Bhiwandi" },
      { label: "Bhiwapur", value: "Bhiwapur" },
      { label: "Bhokar", value: "Bhokar" },
      { label: "Bhokardan", value: "Bhokardan" },
      { label: "Bhoom", value: "Bhoom" },
      { label: "Bhor", value: "Bhor" },
      { label: "Bhudargad", value: "Bhudargad" },
      { label: "Bhusawal", value: "Bhusawal" },
      { label: "Billoli", value: "Billoli" },
      { label: "Brahmapuri", value: "Brahmapuri" },
      { label: "Buldhana", value: "Buldhana" },
      { label: "Butibori", value: "Butibori" },
      { label: "Chalisgaon", value: "Chalisgaon" },
      { label: "Chamorshi", value: "Chamorshi" },
      { label: "Chandgad", value: "Chandgad" },
      { label: "Chandrapur", value: "Chandrapur" },
      { label: "Chandur", value: "Chandur" },
      { label: "Chanwad", value: "Chanwad" },
      { label: "Chhikaldara", value: "Chhikaldara" },
      { label: "Chikhali", value: "Chikhali" },
      { label: "Chinchwad", value: "Chinchwad" },
      { label: "Chiplun", value: "Chiplun" },
      { label: "Chopda", value: "Chopda" },
      { label: "Chumur", value: "Chumur" },
      { label: "Dahanu", value: "Dahanu" },
      { label: "Dapoli", value: "Dapoli" },
      { label: "Darwaha", value: "Darwaha" },
      { label: "Daryapur", value: "Daryapur" },
      { label: "Daund", value: "Daund" },
      { label: "Degloor", value: "Degloor" },
      { label: "Delhi Tanda", value: "Delhi Tanda" },
      { label: "Deogad", value: "Deogad" },
      { label: "Deolgaonraja", value: "Deolgaonraja" },
      { label: "Deori", value: "Deori" },
      { label: "Desaiganj", value: "Desaiganj" },
      { label: "Dhadgaon", value: "Dhadgaon" },
      { label: "Dhanora", value: "Dhanora" },
      { label: "Dharani", value: "Dharani" },
      { label: "Dhiwadi", value: "Dhiwadi" },
      { label: "Dhule", value: "Dhule" },
      { label: "Dhulia", value: "Dhulia" },
      { label: "Digras", value: "Digras" },
      { label: "Dindori", value: "Dindori" },
      { label: "Edalabad", value: "Edalabad" },
      { label: "Erandul", value: "Erandul" },
      { label: "Etapalli", value: "Etapalli" },
      { label: "Gadhchiroli", value: "Gadhchiroli" },
      { label: "Gadhinglaj", value: "Gadhinglaj" },
      { label: "Gaganbavada", value: "Gaganbavada" },
      { label: "Gangakhed", value: "Gangakhed" },
      { label: "Gangapur", value: "Gangapur" },
      { label: "Gevrai", value: "Gevrai" },
      { label: "Ghatanji", value: "Ghatanji" },
      { label: "Golegaon", value: "Golegaon" },
      { label: "Gondia", value: "Gondia" },
      { label: "Gondpipri", value: "Gondpipri" },
      { label: "Goregaon", value: "Goregaon" },
      { label: "Guhagar", value: "Guhagar" },
      { label: "Hadgaon", value: "Hadgaon" },
      { label: "Hatkangale", value: "Hatkangale" },
      { label: "Hinganghat", value: "Hinganghat" },
      { label: "Hingoli", value: "Hingoli" },
      { label: "Hingua", value: "Hingua" },
      { label: "Igatpuri", value: "Igatpuri" },
      { label: "Indapur", value: "Indapur" },
      { label: "Islampur", value: "Islampur" },
      { label: "Jalgaon", value: "Jalgaon" },
      { label: "Jalna", value: "Jalna" },
      { label: "Jamkhed", value: "Jamkhed" },
      { label: "Jamner", value: "Jamner" },
      { label: "Jath", value: "Jath" },
      { label: "Jawahar", value: "Jawahar" },
      { label: "Jintdor", value: "Jintdor" },
      { label: "Junnar", value: "Junnar" },
      { label: "Kagal", value: "Kagal" },
      { label: "Kaij", value: "Kaij" },
      { label: "Kalamb", value: "Kalamb" },
      { label: "Kalamnuri", value: "Kalamnuri" },
      { label: "Kallam", value: "Kallam" },
      { label: "Kalmeshwar", value: "Kalmeshwar" },
      { label: "Kalwan", value: "Kalwan" },
      { label: "Kalyan", value: "Kalyan" },
      { label: "Kamptee", value: "Kamptee" },
      { label: "Kandhar", value: "Kandhar" },
      { label: "Kankavali", value: "Kankavali" },
      { label: "Kannad", value: "Kannad" },
      { label: "Karad", value: "Karad" },
      { label: "Karjat", value: "Karjat" },
      { label: "Karmala", value: "Karmala" },
      { label: "Katol", value: "Katol" },
      { label: "Kavathemankal", value: "Kavathemankal" },
      { label: "Kedgaon", value: "Kedgaon" },
      { label: "Khadakwasala", value: "Khadakwasala" },
      { label: "Khamgaon", value: "Khamgaon" },
      { label: "Khed", value: "Khed" },
      { label: "Khopoli", value: "Khopoli" },
      { label: "Khultabad", value: "Khultabad" },
      { label: "Kinwat", value: "Kinwat" },
      { label: "Kolhapur", value: "Kolhapur" },
      { label: "Kopargaon", value: "Kopargaon" },
      { label: "Koregaon", value: "Koregaon" },
      { label: "Kudal", value: "Kudal" },
      { label: "Kuhi", value: "Kuhi" },
      { label: "Kurkheda", value: "Kurkheda" },
      { label: "Kusumba", value: "Kusumba" },
      { label: "Lakhandur", value: "Lakhandur" },
      { label: "Langa", value: "Langa" },
      { label: "Latur", value: "Latur" },
      { label: "Lonar", value: "Lonar" },
      { label: "Lonavala", value: "Lonavala" },
      { label: "Madangad", value: "Madangad" },
      { label: "Madha", value: "Madha" },
      { label: "Mahabaleshwar", value: "Mahabaleshwar" },
      { label: "Mahad", value: "Mahad" },
      { label: "Mahagaon", value: "Mahagaon" },
      { label: "Mahasala", value: "Mahasala" },
      { label: "Mahaswad", value: "Mahaswad" },
      { label: "Malegaon", value: "Malegaon" },
      { label: "Malgaon", value: "Malgaon" },
      { label: "Malgund", value: "Malgund" },
      { label: "Malkapur", value: "Malkapur" },
      { label: "Malsuras", value: "Malsuras" },
      { label: "Malwan", value: "Malwan" },
      { label: "Mancher", value: "Mancher" },
      { label: "Mangalwedha", value: "Mangalwedha" },
      { label: "Mangaon", value: "Mangaon" },
      { label: "Mangrulpur", value: "Mangrulpur" },
      { label: "Manjalegaon", value: "Manjalegaon" },
      { label: "Manmad", value: "Manmad" },
      { label: "Maregaon", value: "Maregaon" },
      { label: "Mehda", value: "Mehda" },
      { label: "Mekhar", value: "Mekhar" },
      { label: "Mohadi", value: "Mohadi" },
      { label: "Mohol", value: "Mohol" },
      { label: "Mokhada", value: "Mokhada" },
      { label: "Morshi", value: "Morshi" },
      { label: "Mouda", value: "Mouda" },
      { label: "Mukhed", value: "Mukhed" },
      { label: "Mul", value: "Mul" },
      { label: "Mumbai", value: "Mumbai" },
      { label: "Murbad", value: "Murbad" },
      { label: "Murtizapur", value: "Murtizapur" },
      { label: "Murud", value: "Murud" },
      { label: "Nagbhir", value: "Nagbhir" },
      { label: "Nagpur", value: "Nagpur" },
      { label: "Nahavara", value: "Nahavara" },
      { label: "Nanded", value: "Nanded" },
      { label: "Nandgaon", value: "Nandgaon" },
      { label: "Nandnva", value: "Nandnva" },
      { label: "Nandurbar", value: "Nandurbar" },
      { label: "Narkhed", value: "Narkhed" },
      { label: "Nashik", value: "Nashik" },
      { label: "Navapur", value: "Navapur" },
      { label: "Ner", value: "Ner" },
      { label: "Newasa", value: "Newasa" },
      { label: "Nilanga", value: "Nilanga" },
      { label: "Niphad", value: "Niphad" },
      { label: "Omerga", value: "Omerga" },
      { label: "Osmanabad", value: "Osmanabad" },
      { label: "Pachora", value: "Pachora" },
      { label: "Paithan", value: "Paithan" },
      { label: "Palghar", value: "Palghar" },
      { label: "Pali", value: "Pali" },
      { label: "Pandharkawada", value: "Pandharkawada" },
      { label: "Pandharpur", value: "Pandharpur" },
      { label: "Panhala", value: "Panhala" },
      { label: "Paranda", value: "Paranda" },
      { label: "Parbhani", value: "Parbhani" },
      { label: "Parner", value: "Parner" },
      { label: "Parola", value: "Parola" },
      { label: "Parseoni", value: "Parseoni" },
      { label: "Partur", value: "Partur" },
      { label: "Patan", value: "Patan" },
      { label: "Pathardi", value: "Pathardi" },
      { label: "Pathari", value: "Pathari" },
      { label: "Patoda", value: "Patoda" },
      { label: "Pauni", value: "Pauni" },
      { label: "Peint", value: "Peint" },
      { label: "Pen", value: "Pen" },
      { label: "Phaltan", value: "Phaltan" },
      { label: "Pimpalner", value: "Pimpalner" },
      { label: "Pirangut", value: "Pirangut" },
      { label: "Poladpur", value: "Poladpur" },
      { label: "Pune", value: "Pune" },
      { label: "Pusad", value: "Pusad" },
      { label: "Pusegaon", value: "Pusegaon" },
      { label: "Radhanagar", value: "Radhanagar" },
      { label: "Rahuri", value: "Rahuri" },
      { label: "Raigad", value: "Raigad" },
      { label: "Rajapur", value: "Rajapur" },
      { label: "Rajgurunagar", value: "Rajgurunagar" },
      { label: "Rajura", value: "Rajura" },
      { label: "Ralegaon", value: "Ralegaon" },
      { label: "Ramtek", value: "Ramtek" },
      { label: "Ratnagiri", value: "Ratnagiri" },
      { label: "Raver", value: "Raver" },
      { label: "Risod", value: "Risod" },
      { label: "Roha", value: "Roha" },
      { label: "Sakarwadi", value: "Sakarwadi" },
      { label: "Sakoli", value: "Sakoli" },
      { label: "Sakri", value: "Sakri" },
      { label: "Salekasa", value: "Salekasa" },
      { label: "Samudrapur", value: "Samudrapur" },
      { label: "Sangamner", value: "Sangamner" },
      { label: "Sanganeshwar", value: "Sanganeshwar" },
      { label: "Sangli", value: "Sangli" },
      { label: "Sangola", value: "Sangola" },
      { label: "Sanguem", value: "Sanguem" },
      { label: "Saoner", value: "Saoner" },
      { label: "Saswad", value: "Saswad" },
      { label: "Satana", value: "Satana" },
      { label: "Satara", value: "Satara" },
      { label: "Sawantwadi", value: "Sawantwadi" },
      { label: "Seloo", value: "Seloo" },
      { label: "Shahada", value: "Shahada" },
      { label: "Shahapur", value: "Shahapur" },
      { label: "Shahuwadi", value: "Shahuwadi" },
      { label: "Shevgaon", value: "Shevgaon" },
      { label: "Shirala", value: "Shirala" },
      { label: "Shirol", value: "Shirol" },
      { label: "Shirpur", value: "Shirpur" },
      { label: "Shirur", value: "Shirur" },
      { label: "Shirwal", value: "Shirwal" },
      { label: "Sholapur", value: "Sholapur" },
      { label: "Shri Rampur", value: "Shri Rampur" },
      { label: "Shrigonda", value: "Shrigonda" },
      { label: "Shrivardhan", value: "Shrivardhan" },
      { label: "Sillod", value: "Sillod" },
      { label: "Sinderwahi", value: "Sinderwahi" },
      { label: "Sindhudurg", value: "Sindhudurg" },
      { label: "Sindkheda", value: "Sindkheda" },
      { label: "Sindkhedaraja", value: "Sindkhedaraja" },
      { label: "Sinnar", value: "Sinnar" },
      { label: "Sironcha", value: "Sironcha" },
      { label: "Soyegaon", value: "Soyegaon" },
      { label: "Surgena", value: "Surgena" },
      { label: "Talasari", value: "Talasari" },
      { label: "Talegaon S.Ji Pant", value: "Talegaon S.Ji Pant" },
      { label: "Taloda", value: "Taloda" },
      { label: "Tasgaon", value: "Tasgaon" },
      { label: "Thane", value: "Thane" },
      { label: "Tirora", value: "Tirora" },
      { label: "Tiwasa", value: "Tiwasa" },
      { label: "Trimbak", value: "Trimbak" },
      { label: "Tuljapur", value: "Tuljapur" },
      { label: "Tumsar", value: "Tumsar" },
      { label: "Udgir", value: "Udgir" },
      { label: "Umarkhed", value: "Umarkhed" },
      { label: "Umrane", value: "Umrane" },
      { label: "Umrer", value: "Umrer" },
      { label: "Urlikanchan", value: "Urlikanchan" },
      { label: "Vaduj", value: "Vaduj" },
      { label: "Velhe", value: "Velhe" },
      { label: "Vengurla", value: "Vengurla" },
      { label: "Vijapur", value: "Vijapur" },
      { label: "Vita", value: "Vita" },
      { label: "Wada", value: "Wada" },
      { label: "Wai", value: "Wai" },
      { label: "Walchandnagar", value: "Walchandnagar" },
      { label: "Wani", value: "Wani" },
      { label: "Wardha", value: "Wardha" },
      { label: "Warlydwarud", value: "Warlydwarud" },
      { label: "Warora", value: "Warora" },
      { label: "Washim", value: "Washim" },
      { label: "Wathar", value: "Wathar" },
      { label: "Yavatmal", value: "Yavatmal" },
      { label: "Yawal", value: "Yawal" },
      { label: "Yeola", value: "Yeola" },
      { label: "Yeotmal", value: "Yeotmal" },
    ],
  },
  {
    label: "Manipur",
    title: "Manipur",
    options: [
      { label: "Bishnupur", value: "Bishnupur" },
      { label: "Chakpikarong", value: "Chakpikarong" },
      { label: "Chandel", value: "Chandel" },
      { label: "Chattrik", value: "Chattrik" },
      { label: "Churachandpur", value: "Churachandpur" },
      { label: "Imphal", value: "Imphal" },
      { label: "Jiribam", value: "Jiribam" },
      { label: "Kakching", value: "Kakching" },
      { label: "Kalapahar", value: "Kalapahar" },
      { label: "Mao", value: "Mao" },
      { label: "Mulam", value: "Mulam" },
      { label: "Parbung", value: "Parbung" },
      { label: "Sadarhills", value: "Sadarhills" },
      { label: "Saibom", value: "Saibom" },
      { label: "Sempang", value: "Sempang" },
      { label: "Senapati", value: "Senapati" },
      { label: "Sochumer", value: "Sochumer" },
      { label: "Taloulong", value: "Taloulong" },
      { label: "Tamenglong", value: "Tamenglong" },
      { label: "Thinghat", value: "Thinghat" },
      { label: "Thoubal", value: "Thoubal" },
      { label: "Ukhrul", value: "Ukhrul" },
    ],
  },
  {
    label: "Meghalaya",
    title: "Meghalaya",
    options: [
      { label: "Amlaren", value: "Amlaren" },
      { label: "Baghmara", value: "Baghmara" },
      { label: "Cherrapunjee", value: "Cherrapunjee" },
      { label: "Dadengiri", value: "Dadengiri" },
      { label: "Garo Hills", value: "Garo Hills" },
      { label: "Jaintia Hills", value: "Jaintia Hills" },
      { label: "Jowai", value: "Jowai" },
      { label: "Khasi Hills", value: "Khasi Hills" },
      { label: "Khliehriat", value: "Khliehriat" },
      { label: "Mariang", value: "Mariang" },
      { label: "Mawkyrwat", value: "Mawkyrwat" },
      { label: "Nongpoh", value: "Nongpoh" },
      { label: "Nongstoin", value: "Nongstoin" },
      { label: "Resubelpara", value: "Resubelpara" },
      { label: "Ri Bhoi", value: "Ri Bhoi" },
      { label: "Shillong", value: "Shillong" },
      { label: "Tura", value: "Tura" },
      { label: "Williamnagar", value: "Williamnagar" },
    ],
  },
  {
    label: "Mizoram",
    title: "Mizoram",
    options: [
      { label: "Aizawl", value: "Aizawl" },
      { label: "Champhai", value: "Champhai" },
      { label: "Demagiri", value: "Demagiri" },
      { label: "Kolasib", value: "Kolasib" },
      { label: "Lawngtlai", value: "Lawngtlai" },
      { label: "Lunglei", value: "Lunglei" },
      { label: "Mamit", value: "Mamit" },
      { label: "Saiha", value: "Saiha" },
      { label: "Serchhip", value: "Serchhip" },
    ],
  },
  {
    label: "Nagaland",
    title: "Nagaland",
    options: [
      { label: "Dimapur", value: "Dimapur" },
      { label: "Jalukie", value: "Jalukie" },
      { label: "Kiphire", value: "Kiphire" },
      { label: "Kohima", value: "Kohima" },
      { label: "Mokokchung", value: "Mokokchung" },
      { label: "Mon", value: "Mon" },
      { label: "Phek", value: "Phek" },
      { label: "Tuensang", value: "Tuensang" },
      { label: "Wokha", value: "Wokha" },
      { label: "Zunheboto", value: "Zunheboto" },
    ],
  },
  {
    label: "Orissa",
    title: "Orissa",
    options: [
      { label: "Anandapur", value: "Anandapur" },
      { label: "Angul", value: "Angul" },
      { label: "Anugul", value: "Anugul" },
      { label: "Aska", value: "Aska" },
      { label: "Athgarh", value: "Athgarh" },
      { label: "Athmallik", value: "Athmallik" },
      { label: "Attabira", value: "Attabira" },
      { label: "Bagdihi", value: "Bagdihi" },
      { label: "Balangir", value: "Balangir" },
      { label: "Balasore", value: "Balasore" },
      { label: "Baleswar", value: "Baleswar" },
      { label: "Baliguda", value: "Baliguda" },
      { label: "Balugaon", value: "Balugaon" },
      { label: "Banaigarh", value: "Banaigarh" },
      { label: "Bangiriposi", value: "Bangiriposi" },
      { label: "Barbil", value: "Barbil" },
      { label: "Bargarh", value: "Bargarh" },
      { label: "Baripada", value: "Baripada" },
      { label: "Barkot", value: "Barkot" },
      { label: "Basta", value: "Basta" },
      { label: "Berhampur", value: "Berhampur" },
      { label: "Betanati", value: "Betanati" },
      { label: "Bhadrak", value: "Bhadrak" },
      { label: "Bhanjanagar", value: "Bhanjanagar" },
      { label: "Bhawanipatna", value: "Bhawanipatna" },
      { label: "Bhubaneswar", value: "Bhubaneswar" },
      { label: "Birmaharajpur", value: "Birmaharajpur" },
      { label: "Bisam Cuttack", value: "Bisam Cuttack" },
      { label: "Boriguma", value: "Boriguma" },
      { label: "Boudh", value: "Boudh" },
      { label: "Buguda", value: "Buguda" },
      { label: "Chandbali", value: "Chandbali" },
      { label: "Chhatrapur", value: "Chhatrapur" },
      { label: "Chhendipada", value: "Chhendipada" },
      { label: "Cuttack", value: "Cuttack" },
      { label: "Daringbadi", value: "Daringbadi" },
      { label: "Daspalla", value: "Daspalla" },
      { label: "Deodgarh", value: "Deodgarh" },
      { label: "Deogarh", value: "Deogarh" },
      { label: "Dhanmandal", value: "Dhanmandal" },
      { label: "Dharamgarh", value: "Dharamgarh" },
      { label: "Dhenkanal", value: "Dhenkanal" },
      { label: "Digapahandi", value: "Digapahandi" },
      { label: "Dunguripali", value: "Dunguripali" },
      { label: "G. Udayagiri", value: "G. Udayagiri" },
      { label: "Gajapati", value: "Gajapati" },
      { label: "Ganjam", value: "Ganjam" },
      { label: "Ghatgaon", value: "Ghatgaon" },
      { label: "Gudari", value: "Gudari" },
      { label: "Gunupur", value: "Gunupur" },
      { label: "Hemgiri", value: "Hemgiri" },
      { label: "Hindol", value: "Hindol" },
      { label: "Jagatsinghapur", value: "Jagatsinghapur" },
      { label: "Jajpur", value: "Jajpur" },
      { label: "Jamankira", value: "Jamankira" },
      { label: "Jashipur", value: "Jashipur" },
      { label: "Jayapatna", value: "Jayapatna" },
      { label: "Jeypur", value: "Jeypur" },
      { label: "Jharigan", value: "Jharigan" },
      { label: "Jharsuguda", value: "Jharsuguda" },
      { label: "Jujumura", value: "Jujumura" },
      { label: "Kalahandi", value: "Kalahandi" },
      { label: "Kalimela", value: "Kalimela" },
      { label: "Kamakhyanagar", value: "Kamakhyanagar" },
      { label: "Kandhamal", value: "Kandhamal" },
      { label: "Kantabhanji", value: "Kantabhanji" },
      { label: "Kantamal", value: "Kantamal" },
      { label: "Karanjia", value: "Karanjia" },
      { label: "Kashipur", value: "Kashipur" },
      { label: "Kendrapara", value: "Kendrapara" },
      { label: "Kendujhar", value: "Kendujhar" },
      { label: "Keonjhar", value: "Keonjhar" },
      { label: "Khalikote", value: "Khalikote" },
      { label: "Khordha", value: "Khordha" },
      { label: "Khurda", value: "Khurda" },
      { label: "Komana", value: "Komana" },
      { label: "Koraput", value: "Koraput" },
      { label: "Kotagarh", value: "Kotagarh" },
      { label: "Kuchinda", value: "Kuchinda" },
      { label: "Lahunipara", value: "Lahunipara" },
      { label: "Laxmipur", value: "Laxmipur" },
      { label: "M. Rampur", value: "M. Rampur" },
      { label: "Malkangiri", value: "Malkangiri" },
      { label: "Mathili", value: "Mathili" },
      { label: "Mayurbhanj", value: "Mayurbhanj" },
      { label: "Mohana", value: "Mohana" },
      { label: "Motu", value: "Motu" },
      { label: "Nabarangapur", value: "Nabarangapur" },
      { label: "Naktideul", value: "Naktideul" },
      { label: "Nandapur", value: "Nandapur" },
      { label: "Narlaroad", value: "Narlaroad" },
      { label: "Narsinghpur", value: "Narsinghpur" },
      { label: "Nayagarh", value: "Nayagarh" },
      { label: "Nimapara", value: "Nimapara" },
      { label: "Nowparatan", value: "Nowparatan" },
      { label: "Nowrangapur", value: "Nowrangapur" },
      { label: "Nuapada", value: "Nuapada" },
      { label: "Padampur", value: "Padampur" },
      { label: "Paikamal", value: "Paikamal" },
      { label: "Palla Hara", value: "Palla Hara" },
      { label: "Papadhandi", value: "Papadhandi" },
      { label: "Parajang", value: "Parajang" },
      { label: "Pardip", value: "Pardip" },
      { label: "Parlakhemundi", value: "Parlakhemundi" },
      { label: "Patnagarh", value: "Patnagarh" },
      { label: "Pattamundai", value: "Pattamundai" },
      { label: "Phiringia", value: "Phiringia" },
      { label: "Phulbani", value: "Phulbani" },
      { label: "Puri", value: "Puri" },
      { label: "Puruna Katak", value: "Puruna Katak" },
      { label: "R. Udayigiri", value: "R. Udayigiri" },
      { label: "Rairakhol", value: "Rairakhol" },
      { label: "Rairangpur", value: "Rairangpur" },
      { label: "Rajgangpur", value: "Rajgangpur" },
      { label: "Rajkhariar", value: "Rajkhariar" },
      { label: "Rayagada", value: "Rayagada" },
      { label: "Rourkela", value: "Rourkela" },
      { label: "Sambalpur", value: "Sambalpur" },
      { label: "Sohela", value: "Sohela" },
      { label: "Sonapur", value: "Sonapur" },
      { label: "Soro", value: "Soro" },
      { label: "Subarnapur", value: "Subarnapur" },
      { label: "Sunabeda", value: "Sunabeda" },
      { label: "Sundergarh", value: "Sundergarh" },
      { label: "Surada", value: "Surada" },
      { label: "T. Rampur", value: "T. Rampur" },
      { label: "Talcher", value: "Talcher" },
      { label: "Telkoi", value: "Telkoi" },
      { label: "Titlagarh", value: "Titlagarh" },
      { label: "Tumudibandha", value: "Tumudibandha" },
      { label: "Udala", value: "Udala" },
      { label: "Umerkote", value: "Umerkote" },
    ],
  },
  {
    label: "Pondicherry",
    title: "Pondicherry",
    options: [
      { label: "Bahur", value: "Bahur" },
      { label: "Karaikal", value: "Karaikal" },
      { label: "Mahe", value: "Mahe" },
      { label: "Pondicherry", value: "Pondicherry" },
      { label: "Purnankuppam", value: "Purnankuppam" },
      { label: "Valudavur", value: "Valudavur" },
      { label: "Villianur", value: "Villianur" },
      { label: "Yanam", value: "Yanam" },
    ],
  },
  {
    label: "Punjab",
    title: "Punjab",
    options: [
      { label: "Abohar", value: "Abohar" },
      { label: "Ajnala", value: "Ajnala" },
      { label: "Amritsar", value: "Amritsar" },
      { label: "Balachaur", value: "Balachaur" },
      { label: "Barnala", value: "Barnala" },
      { label: "Batala", value: "Batala" },
      { label: "Bathinda", value: "Bathinda" },
      { label: "Chandigarh", value: "Chandigarh" },
      { label: "Dasua", value: "Dasua" },
      { label: "Dinanagar", value: "Dinanagar" },
      { label: "Faridkot", value: "Faridkot" },
      { label: "Fatehgarh Sahib", value: "Fatehgarh Sahib" },
      { label: "Fazilka", value: "Fazilka" },
      { label: "Ferozepur", value: "Ferozepur" },
      { label: "Garhashanker", value: "Garhashanker" },
      { label: "Goindwal", value: "Goindwal" },
      { label: "Gurdaspur", value: "Gurdaspur" },
      { label: "Guruharsahai", value: "Guruharsahai" },
      { label: "Hoshiarpur", value: "Hoshiarpur" },
      { label: "Jagraon", value: "Jagraon" },
      { label: "Jalandhar", value: "Jalandhar" },
      { label: "Jugial", value: "Jugial" },
      { label: "Kapurthala", value: "Kapurthala" },
      { label: "Kharar", value: "Kharar" },
      { label: "Kotkapura", value: "Kotkapura" },
      { label: "Ludhiana", value: "Ludhiana" },
      { label: "Malaut", value: "Malaut" },
      { label: "Malerkotla", value: "Malerkotla" },
      { label: "Mansa", value: "Mansa" },
      { label: "Moga", value: "Moga" },
      { label: "Muktasar", value: "Muktasar" },
      { label: "Nabha", value: "Nabha" },
      { label: "Nakodar", value: "Nakodar" },
      { label: "Nangal", value: "Nangal" },
      { label: "Nawanshahar", value: "Nawanshahar" },
      { label: "Nawanshahr", value: "Nawanshahr" },
      { label: "Pathankot", value: "Pathankot" },
      { label: "Patiala", value: "Patiala" },
      { label: "Patti", value: "Patti" },
      { label: "Phagwara", value: "Phagwara" },
      { label: "Phillaur", value: "Phillaur" },
      { label: "Phulmandi", value: "Phulmandi" },
      { label: "Quadian", value: "Quadian" },
      { label: "Rajpura", value: "Rajpura" },
      { label: "Raman", value: "Raman" },
      { label: "Rayya", value: "Rayya" },
      { label: "Ropar", value: "Ropar" },
      { label: "Rupnagar", value: "Rupnagar" },
      { label: "Samana", value: "Samana" },
      { label: "Samrala", value: "Samrala" },
      { label: "Sangrur", value: "Sangrur" },
      { label: "Sardulgarh", value: "Sardulgarh" },
      { label: "Sarhind", value: "Sarhind" },
      { label: "SAS Nagar", value: "SAS Nagar" },
      { label: "Sultanpur Lodhi", value: "Sultanpur Lodhi" },
      { label: "Sunam", value: "Sunam" },
      { label: "Tanda Urmar", value: "Tanda Urmar" },
      { label: "Tarn Taran", value: "Tarn Taran" },
      { label: "Zira", value: "Zira" },
    ],
  },
  {
    label: "Rajasthan",
    title: "Rajasthan",
    options: [
      { label: "Abu Road", value: "Abu Road" },
      { label: "Ahore", value: "Ahore" },
      { label: "Ajmer", value: "Ajmer" },
      { label: "Aklera", value: "Aklera" },
      { label: "Alwar", value: "Alwar" },
      { label: "Amber", value: "Amber" },
      { label: "Amet", value: "Amet" },
      { label: "Anupgarh", value: "Anupgarh" },
      { label: "Asind", value: "Asind" },
      { label: "Aspur", value: "Aspur" },
      { label: "Atru", value: "Atru" },
      { label: "Bagidora", value: "Bagidora" },
      { label: "Bali", value: "Bali" },
      { label: "Bamanwas", value: "Bamanwas" },
      { label: "Banera", value: "Banera" },
      { label: "Bansur", value: "Bansur" },
      { label: "Banswara", value: "Banswara" },
      { label: "Baran", value: "Baran" },
      { label: "Bari", value: "Bari" },
      { label: "Barisadri", value: "Barisadri" },
      { label: "Barmer", value: "Barmer" },
      { label: "Baseri", value: "Baseri" },
      { label: "Bassi", value: "Bassi" },
      { label: "Baswa", value: "Baswa" },
      { label: "Bayana", value: "Bayana" },
      { label: "Beawar", value: "Beawar" },
      { label: "Begun", value: "Begun" },
      { label: "Behror", value: "Behror" },
      { label: "Bhadra", value: "Bhadra" },
      { label: "Bharatpur", value: "Bharatpur" },
      { label: "Bhilwara", value: "Bhilwara" },
      { label: "Bhim", value: "Bhim" },
      { label: "Bhinmal", value: "Bhinmal" },
      { label: "Bikaner", value: "Bikaner" },
      { label: "Bilara", value: "Bilara" },
      { label: "Bundi", value: "Bundi" },
      { label: "Chhabra", value: "Chhabra" },
      { label: "Chhipaborad", value: "Chhipaborad" },
      { label: "Chirawa", value: "Chirawa" },
      { label: "Chittorgarh", value: "Chittorgarh" },
      { label: "Chohtan", value: "Chohtan" },
      { label: "Churu", value: "Churu" },
      { label: "Dantaramgarh", value: "Dantaramgarh" },
      { label: "Dausa", value: "Dausa" },
      { label: "Deedwana", value: "Deedwana" },
      { label: "Deeg", value: "Deeg" },
      { label: "Degana", value: "Degana" },
      { label: "Deogarh", value: "Deogarh" },
      { label: "Deoli", value: "Deoli" },
      { label: "Desuri", value: "Desuri" },
      { label: "Dhariawad", value: "Dhariawad" },
      { label: "Dholpur", value: "Dholpur" },
      { label: "Digod", value: "Digod" },
      { label: "Dudu", value: "Dudu" },
      { label: "Dungarpur", value: "Dungarpur" },
      { label: "Dungla", value: "Dungla" },
      { label: "Fatehpur", value: "Fatehpur" },
      { label: "Gangapur", value: "Gangapur" },
      { label: "Gangdhar", value: "Gangdhar" },
      { label: "Gerhi", value: "Gerhi" },
      { label: "Ghatol", value: "Ghatol" },
      { label: "Girwa", value: "Girwa" },
      { label: "Gogunda", value: "Gogunda" },
      { label: "Hanumangarh", value: "Hanumangarh" },
      { label: "Hindaun", value: "Hindaun" },
      { label: "Hindoli", value: "Hindoli" },
      { label: "Hurda", value: "Hurda" },
      { label: "Jahazpur", value: "Jahazpur" },
      { label: "Jaipur", value: "Jaipur" },
      { label: "Jaisalmer", value: "Jaisalmer" },
      { label: "Jalore", value: "Jalore" },
      { label: "Jhalawar", value: "Jhalawar" },
      { label: "Jhunjhunu", value: "Jhunjhunu" },
      { label: "Jodhpur", value: "Jodhpur" },
      { label: "Kaman", value: "Kaman" },
      { label: "Kapasan", value: "Kapasan" },
      { label: "Karauli", value: "Karauli" },
      { label: "Kekri", value: "Kekri" },
      { label: "Keshoraipatan", value: "Keshoraipatan" },
      { label: "Khandar", value: "Khandar" },
      { label: "Kherwara", value: "Kherwara" },
      { label: "Khetri", value: "Khetri" },
      { label: "Kishanganj", value: "Kishanganj" },
      { label: "Kishangarh", value: "Kishangarh" },
      { label: "Kishangarhbas", value: "Kishangarhbas" },
      { label: "Kolayat", value: "Kolayat" },
      { label: "Kota", value: "Kota" },
      { label: "Kotputli", value: "Kotputli" },
      { label: "Kotra", value: "Kotra" },
      { label: "Kotri", value: "Kotri" },
      { label: "Kumbalgarh", value: "Kumbalgarh" },
      { label: "Kushalgarh", value: "Kushalgarh" },
      { label: "Ladnun", value: "Ladnun" },
      { label: "Ladpura", value: "Ladpura" },
      { label: "Lalsot", value: "Lalsot" },
      { label: "Laxmangarh", value: "Laxmangarh" },
      { label: "Lunkaransar", value: "Lunkaransar" },
      { label: "Mahuwa", value: "Mahuwa" },
      { label: "Malpura", value: "Malpura" },
      { label: "Malvi", value: "Malvi" },
      { label: "Mandal", value: "Mandal" },
      { label: "Mandalgarh", value: "Mandalgarh" },
      { label: "Mandawar", value: "Mandawar" },
      { label: "Mangrol", value: "Mangrol" },
      { label: "Marwar-Jn", value: "Marwar-Jn" },
      { label: "Merta", value: "Merta" },
      { label: "Nadbai", value: "Nadbai" },
      { label: "Nagaur", value: "Nagaur" },
      { label: "Nainwa", value: "Nainwa" },
      { label: "Nasirabad", value: "Nasirabad" },
      { label: "Nathdwara", value: "Nathdwara" },
      { label: "Nawa", value: "Nawa" },
      { label: "Neem Ka Thana", value: "Neem Ka Thana" },
      { label: "Newai", value: "Newai" },
      { label: "Nimbahera", value: "Nimbahera" },
      { label: "Nohar", value: "Nohar" },
      { label: "Nokha", value: "Nokha" },
      { label: "Onli", value: "Onli" },
      { label: "Osian", value: "Osian" },
      { label: "Pachpadara", value: "Pachpadara" },
      { label: "Pachpahar", value: "Pachpahar" },
      { label: "Padampur", value: "Padampur" },
      { label: "Pali", value: "Pali" },
      { label: "Parbatsar", value: "Parbatsar" },
      { label: "Phagi", value: "Phagi" },
      { label: "Phalodi", value: "Phalodi" },
      { label: "Pilani", value: "Pilani" },
      { label: "Pindwara", value: "Pindwara" },
      { label: "Pipalda", value: "Pipalda" },
      { label: "Pirawa", value: "Pirawa" },
      { label: "Pokaran", value: "Pokaran" },
      { label: "Pratapgarh", value: "Pratapgarh" },
      { label: "Raipur", value: "Raipur" },
      { label: "Raisinghnagar", value: "Raisinghnagar" },
      { label: "Rajgarh", value: "Rajgarh" },
      { label: "Rajsamand", value: "Rajsamand" },
      { label: "Ramganj Mandi", value: "Ramganj Mandi" },
      { label: "Ramgarh", value: "Ramgarh" },
      { label: "Rashmi", value: "Rashmi" },
      { label: "Ratangarh", value: "Ratangarh" },
      { label: "Reodar", value: "Reodar" },
      { label: "Rupbas", value: "Rupbas" },
      { label: "Sadulshahar", value: "Sadulshahar" },
      { label: "Sagwara", value: "Sagwara" },
      { label: "Sahabad", value: "Sahabad" },
      { label: "Salumber", value: "Salumber" },
      { label: "Sanchore", value: "Sanchore" },
      { label: "Sangaria", value: "Sangaria" },
      { label: "Sangod", value: "Sangod" },
      { label: "Sapotra", value: "Sapotra" },
      { label: "Sarada", value: "Sarada" },
      { label: "Sardarshahar", value: "Sardarshahar" },
      { label: "Sarwar", value: "Sarwar" },
      { label: "Sawai Madhopur", value: "Sawai Madhopur" },
      { label: "Shahapura", value: "Shahapura" },
      { label: "Sheo", value: "Sheo" },
      { label: "Sheoganj", value: "Sheoganj" },
      { label: "Shergarh", value: "Shergarh" },
      { label: "Sikar", value: "Sikar" },
      { label: "Sirohi", value: "Sirohi" },
      { label: "Siwana", value: "Siwana" },
      { label: "Sojat", value: "Sojat" },
      { label: "Sri Dungargarh", value: "Sri Dungargarh" },
      { label: "Sri Ganganagar", value: "Sri Ganganagar" },
      { label: "Sri Karanpur", value: "Sri Karanpur" },
      { label: "Sri Madhopur", value: "Sri Madhopur" },
      { label: "Sujangarh", value: "Sujangarh" },
      { label: "Taranagar", value: "Taranagar" },
      { label: "Thanaghazi", value: "Thanaghazi" },
      { label: "Tibbi", value: "Tibbi" },
      { label: "Tijara", value: "Tijara" },
      { label: "Todaraisingh", value: "Todaraisingh" },
      { label: "Tonk", value: "Tonk" },
      { label: "Udaipur", value: "Udaipur" },
      { label: "Udaipurwati", value: "Udaipurwati" },
      { label: "Uniayara", value: "Uniayara" },
      { label: "Vallabhnagar", value: "Vallabhnagar" },
      { label: "Viratnagar", value: "Viratnagar" },
    ],
  },
  {
    label: "Sikkim",
    title: "Sikkim",
    options: [
      { label: "Barmiak", value: "Barmiak" },
      { label: "Be", value: "Be" },
      { label: "Bhurtuk", value: "Bhurtuk" },
      { label: "Chhubakha", value: "Chhubakha" },
      { label: "Chidam", value: "Chidam" },
      { label: "Chubha", value: "Chubha" },
      { label: "Chumikteng", value: "Chumikteng" },
      { label: "Dentam", value: "Dentam" },
      { label: "Dikchu", value: "Dikchu" },
      { label: "Dzongri", value: "Dzongri" },
      { label: "Gangtok", value: "Gangtok" },
      { label: "Gauzing", value: "Gauzing" },
      { label: "Gyalshing", value: "Gyalshing" },
      { label: "Hema", value: "Hema" },
      { label: "Kerung", value: "Kerung" },
      { label: "Lachen", value: "Lachen" },
      { label: "Lachung", value: "Lachung" },
      { label: "Lema", value: "Lema" },
      { label: "Lingtam", value: "Lingtam" },
      { label: "Lungthu", value: "Lungthu" },
      { label: "Mangan", value: "Mangan" },
      { label: "Namchi", value: "Namchi" },
      { label: "Namthang", value: "Namthang" },
      { label: "Nanga", value: "Nanga" },
      { label: "Nantang", value: "Nantang" },
      { label: "Naya Bazar", value: "Naya Bazar" },
      { label: "Padamachen", value: "Padamachen" },
      { label: "Pakhyong", value: "Pakhyong" },
      { label: "Pemayangtse", value: "Pemayangtse" },
      { label: "Phensang", value: "Phensang" },
      { label: "Rangli", value: "Rangli" },
      { label: "Rinchingpong", value: "Rinchingpong" },
      { label: "Sakyong", value: "Sakyong" },
      { label: "Samdong", value: "Samdong" },
      { label: "Singtam", value: "Singtam" },
      { label: "Siniolchu", value: "Siniolchu" },
      { label: "Sombari", value: "Sombari" },
      { label: "Soreng", value: "Soreng" },
      { label: "Sosing", value: "Sosing" },
      { label: "Tekhug", value: "Tekhug" },
      { label: "Temi", value: "Temi" },
      { label: "Tsetang", value: "Tsetang" },
      { label: "Tsomgo", value: "Tsomgo" },
      { label: "Tumlong", value: "Tumlong" },
      { label: "Yangang", value: "Yangang" },
      { label: "Yumtang", value: "Yumtang" },
    ],
  },
  {
    label: "Tamil Nadu",
    title: "Tamil Nadu",
    options: [
      { label: "Ambasamudram", value: "Ambasamudram" },
      { label: "Anamali", value: "Anamali" },
      { label: "Arakandanallur", value: "Arakandanallur" },
      { label: "Arantangi", value: "Arantangi" },
      { label: "Aravakurichi", value: "Aravakurichi" },
      { label: "Ariyalur", value: "Ariyalur" },
      { label: "Arkonam", value: "Arkonam" },
      { label: "Arni", value: "Arni" },
      { label: "Aruppukottai", value: "Aruppukottai" },
      { label: "Attur", value: "Attur" },
      { label: "Avanashi", value: "Avanashi" },
      { label: "Batlagundu", value: "Batlagundu" },
      { label: "Bhavani", value: "Bhavani" },
      { label: "Chengalpattu", value: "Chengalpattu" },
      { label: "Chengam", value: "Chengam" },
      { label: "Chennai", value: "Chennai" },
      { label: "Chidambaram", value: "Chidambaram" },
      { label: "Chingleput", value: "Chingleput" },
      { label: "Coimbatore", value: "Coimbatore" },
      { label: "Courtallam", value: "Courtallam" },
      { label: "Cuddalore", value: "Cuddalore" },
      { label: "Cumbum", value: "Cumbum" },
      { label: "Denkanikoitah", value: "Denkanikoitah" },
      { label: "Devakottai", value: "Devakottai" },
      { label: "Dharampuram", value: "Dharampuram" },
      { label: "Dharmapuri", value: "Dharmapuri" },
      { label: "Dindigul", value: "Dindigul" },
      { label: "Erode", value: "Erode" },
      { label: "Gingee", value: "Gingee" },
      { label: "Gobichettipalayam", value: "Gobichettipalayam" },
      { label: "Gudalur", value: "Gudalur" },
      { label: "Gudiyatham", value: "Gudiyatham" },
      { label: "Harur", value: "Harur" },
      { label: "Hosur", value: "Hosur" },
      { label: "Jayamkondan", value: "Jayamkondan" },
      { label: "Kallkurichi", value: "Kallkurichi" },
      { label: "Kanchipuram", value: "Kanchipuram" },
      { label: "Kangayam", value: "Kangayam" },
      { label: "Kanyakumari", value: "Kanyakumari" },
      { label: "Karaikal", value: "Karaikal" },
      { label: "Karaikudi", value: "Karaikudi" },
      { label: "Karur", value: "Karur" },
      { label: "Keeranur", value: "Keeranur" },
      { label: "Kodaikanal", value: "Kodaikanal" },
      { label: "Kodumudi", value: "Kodumudi" },
      { label: "Kotagiri", value: "Kotagiri" },
      { label: "Kovilpatti", value: "Kovilpatti" },
      { label: "Krishnagiri", value: "Krishnagiri" },
      { label: "Kulithalai", value: "Kulithalai" },
      { label: "Kumbakonam", value: "Kumbakonam" },
      { label: "Kuzhithurai", value: "Kuzhithurai" },
      { label: "Madurai", value: "Madurai" },
      { label: "Madurantgam", value: "Madurantgam" },
      { label: "Manamadurai", value: "Manamadurai" },
      { label: "Manaparai", value: "Manaparai" },
      { label: "Mannargudi", value: "Mannargudi" },
      { label: "Mayiladuthurai", value: "Mayiladuthurai" },
      { label: "Mayiladutjurai", value: "Mayiladutjurai" },
      { label: "Mettupalayam", value: "Mettupalayam" },
      { label: "Metturdam", value: "Metturdam" },
      { label: "Mudukulathur", value: "Mudukulathur" },
      { label: "Mulanur", value: "Mulanur" },
      { label: "Musiri", value: "Musiri" },
      { label: "Nagapattinam", value: "Nagapattinam" },
      { label: "Nagarcoil", value: "Nagarcoil" },
      { label: "Namakkal", value: "Namakkal" },
      { label: "Nanguneri", value: "Nanguneri" },
      { label: "Natham", value: "Natham" },
      { label: "Neyveli", value: "Neyveli" },
      { label: "Nilgiris", value: "Nilgiris" },
      { label: "Oddanchatram", value: "Oddanchatram" },
      { label: "Omalpur", value: "Omalpur" },
      { label: "Ootacamund", value: "Ootacamund" },
      { label: "Ooty", value: "Ooty" },
      { label: "Orathanad", value: "Orathanad" },
      { label: "Palacode", value: "Palacode" },
      { label: "Palani", value: "Palani" },
      { label: "Palladum", value: "Palladum" },
      { label: "Papanasam", value: "Papanasam" },
      { label: "Paramakudi", value: "Paramakudi" },
      { label: "Pattukottai", value: "Pattukottai" },
      { label: "Perambalur", value: "Perambalur" },
      { label: "Perundurai", value: "Perundurai" },
      { label: "Pollachi", value: "Pollachi" },
      { label: "Polur", value: "Polur" },
      { label: "Pondicherry", value: "Pondicherry" },
      { label: "Ponnamaravathi", value: "Ponnamaravathi" },
      { label: "Ponneri", value: "Ponneri" },
      { label: "Pudukkottai", value: "Pudukkottai" },
      { label: "Rajapalayam", value: "Rajapalayam" },
      { label: "Ramanathapuram", value: "Ramanathapuram" },
      { label: "Rameshwaram", value: "Rameshwaram" },
      { label: "Ranipet", value: "Ranipet" },
      { label: "Rasipuram", value: "Rasipuram" },
      { label: "Salem", value: "Salem" },
      { label: "Sankagiri", value: "Sankagiri" },
      { label: "Sankaran", value: "Sankaran" },
      { label: "Sathiyamangalam", value: "Sathiyamangalam" },
      { label: "Sivaganga", value: "Sivaganga" },
      { label: "Sivakasi", value: "Sivakasi" },
      { label: "Sriperumpudur", value: "Sriperumpudur" },
      { label: "Srivaikundam", value: "Srivaikundam" },
      { label: "Tenkasi", value: "Tenkasi" },
      { label: "Thanjavur", value: "Thanjavur" },
      { label: "Theni", value: "Theni" },
      { label: "Thirumanglam", value: "Thirumanglam" },
      { label: "Thiruraipoondi", value: "Thiruraipoondi" },
      { label: "Thoothukudi", value: "Thoothukudi" },
      { label: "Thuraiyure", value: "Thuraiyure" },
      { label: "Tindivanam", value: "Tindivanam" },
      { label: "Tiruchendur", value: "Tiruchendur" },
      { label: "Tiruchengode", value: "Tiruchengode" },
      { label: "Tiruchirappalli", value: "Tiruchirappalli" },
      { label: "Tirunelvelli", value: "Tirunelvelli" },
      { label: "Tirupathur", value: "Tirupathur" },
      { label: "Tirupur", value: "Tirupur" },
      { label: "Tiruttani", value: "Tiruttani" },
      { label: "Tiruvallur", value: "Tiruvallur" },
      { label: "Tiruvannamalai", value: "Tiruvannamalai" },
      { label: "Tiruvarur", value: "Tiruvarur" },
      { label: "Tiruvellore", value: "Tiruvellore" },
      { label: "Tiruvettipuram", value: "Tiruvettipuram" },
      { label: "Trichy", value: "Trichy" },
      { label: "Tuticorin", value: "Tuticorin" },
      { label: "Udumalpet", value: "Udumalpet" },
      { label: "Ulundurpet", value: "Ulundurpet" },
      { label: "Usiliampatti", value: "Usiliampatti" },
      { label: "Uthangarai", value: "Uthangarai" },
      { label: "Valapady", value: "Valapady" },
      { label: "Valliyoor", value: "Valliyoor" },
      { label: "Vaniyambadi", value: "Vaniyambadi" },
      { label: "Vedasandur", value: "Vedasandur" },
      { label: "Vellore", value: "Vellore" },
      { label: "Velur", value: "Velur" },
      { label: "Vilathikulam", value: "Vilathikulam" },
      { label: "Villupuram", value: "Villupuram" },
      { label: "Virudhachalam", value: "Virudhachalam" },
      { label: "Virudhunagar", value: "Virudhunagar" },
      { label: "Wandiwash", value: "Wandiwash" },
      { label: "Yercaud", value: "Yercaud" },
    ],
  },
  {
    label: "Tripura",
    title: "Tripura",
    options: [
      { label: "Agartala", value: "Agartala" },
      { label: "Ambasa", value: "Ambasa" },
      { label: "Bampurbari", value: "Bampurbari" },
      { label: "Belonia", value: "Belonia" },
      { label: "Dhalai", value: "Dhalai" },
      { label: "Dharam Nagar", value: "Dharam Nagar" },
      { label: "Kailashahar", value: "Kailashahar" },
      { label: "Kamal Krishnabari", value: "Kamal Krishnabari" },
      { label: "Khopaiyapara", value: "Khopaiyapara" },
      { label: "Khowai", value: "Khowai" },
      { label: "Phuldungsei", value: "Phuldungsei" },
      { label: "Radha Kishore Pur", value: "Radha Kishore Pur" },
      { label: "Tripura", value: "Tripura" },
    ],
  },
  {
    label: "Uttar Pradesh",
    title: "Uttar Pradesh",
    options: [
      { label: "Achhnera", value: "Achhnera" },
      { label: "Agra", value: "Agra" },
      { label: "Akbarpur", value: "Akbarpur" },
      { label: "Aliganj", value: "Aliganj" },
      { label: "Aligarh", value: "Aligarh" },
      { label: "Allahabad", value: "Allahabad" },
      { label: "Ambedkar Nagar", value: "Ambedkar Nagar" },
      { label: "Amethi", value: "Amethi" },
      { label: "Amiliya", value: "Amiliya" },
      { label: "Amroha", value: "Amroha" },
      { label: "Anola", value: "Anola" },
      { label: "Atrauli", value: "Atrauli" },
      { label: "Auraiya", value: "Auraiya" },
      { label: "Azamgarh", value: "Azamgarh" },
      { label: "Baberu", value: "Baberu" },
      { label: "Badaun", value: "Badaun" },
      { label: "Baghpat", value: "Baghpat" },
      { label: "Bagpat", value: "Bagpat" },
      { label: "Baheri", value: "Baheri" },
      { label: "Bahraich", value: "Bahraich" },
      { label: "Ballia", value: "Ballia" },
      { label: "Balrampur", value: "Balrampur" },
      { label: "Banda", value: "Banda" },
      { label: "Bansdeeh", value: "Bansdeeh" },
      { label: "Bansgaon", value: "Bansgaon" },
      { label: "Bansi", value: "Bansi" },
      { label: "Barabanki", value: "Barabanki" },
      { label: "Bareilly", value: "Bareilly" },
      { label: "Basti", value: "Basti" },
      { label: "Bhadohi", value: "Bhadohi" },
      { label: "Bharthana", value: "Bharthana" },
      { label: "Bharwari", value: "Bharwari" },
      { label: "Bhogaon", value: "Bhogaon" },
      { label: "Bhognipur", value: "Bhognipur" },
      { label: "Bidhuna", value: "Bidhuna" },
      { label: "Bijnore", value: "Bijnore" },
      { label: "Bikapur", value: "Bikapur" },
      { label: "Bilari", value: "Bilari" },
      { label: "Bilgram", value: "Bilgram" },
      { label: "Bilhaur", value: "Bilhaur" },
      { label: "Bindki", value: "Bindki" },
      { label: "Bisalpur", value: "Bisalpur" },
      { label: "Bisauli", value: "Bisauli" },
      { label: "Biswan", value: "Biswan" },
      { label: "Budaun", value: "Budaun" },
      { label: "Budhana", value: "Budhana" },
      { label: "Bulandshahar", value: "Bulandshahar" },
      { label: "Bulandshahr", value: "Bulandshahr" },
      { label: "Capianganj", value: "Capianganj" },
      { label: "Chakia", value: "Chakia" },
      { label: "Chandauli", value: "Chandauli" },
      { label: "Charkhari", value: "Charkhari" },
      { label: "Chhata", value: "Chhata" },
      { label: "Chhibramau", value: "Chhibramau" },
      { label: "Chirgaon", value: "Chirgaon" },
      { label: "Chitrakoot", value: "Chitrakoot" },
      { label: "Chunur", value: "Chunur" },
      { label: "Dadri", value: "Dadri" },
      { label: "Dalmau", value: "Dalmau" },
      { label: "Dataganj", value: "Dataganj" },
      { label: "Debai", value: "Debai" },
      { label: "Deoband", value: "Deoband" },
      { label: "Deoria", value: "Deoria" },
      { label: "Derapur", value: "Derapur" },
      { label: "Dhampur", value: "Dhampur" },
      { label: "Domariyaganj", value: "Domariyaganj" },
      { label: "Dudhi", value: "Dudhi" },
      { label: "Etah", value: "Etah" },
      { label: "Etawah", value: "Etawah" },
      { label: "Faizabad", value: "Faizabad" },
      { label: "Farrukhabad", value: "Farrukhabad" },
      { label: "Fatehpur", value: "Fatehpur" },
      { label: "Firozabad", value: "Firozabad" },
      { label: "Garauth", value: "Garauth" },
      { label: "Garhmukteshwar", value: "Garhmukteshwar" },
      { label: "Gautam Buddha Nagar", value: "Gautam Buddha Nagar" },
      { label: "Ghatampur", value: "Ghatampur" },
      { label: "Ghaziabad", value: "Ghaziabad" },
      { label: "Ghazipur", value: "Ghazipur" },
      { label: "Ghosi", value: "Ghosi" },
      { label: "Gonda", value: "Gonda" },
      { label: "Gorakhpur", value: "Gorakhpur" },
      { label: "Gunnaur", value: "Gunnaur" },
      { label: "Haidergarh", value: "Haidergarh" },
      { label: "Hamirpur", value: "Hamirpur" },
      { label: "Hapur", value: "Hapur" },
      { label: "Hardoi", value: "Hardoi" },
      { label: "Harraiya", value: "Harraiya" },
      { label: "Hasanganj", value: "Hasanganj" },
      { label: "Hasanpur", value: "Hasanpur" },
      { label: "Hathras", value: "Hathras" },
      { label: "Jalalabad", value: "Jalalabad" },
      { label: "Jalaun", value: "Jalaun" },
      { label: "Jalesar", value: "Jalesar" },
      { label: "Jansath", value: "Jansath" },
      { label: "Jarar", value: "Jarar" },
      { label: "Jasrana", value: "Jasrana" },
      { label: "Jaunpur", value: "Jaunpur" },
      { label: "Jhansi", value: "Jhansi" },
      { label: "Jyotiba Phule Nagar", value: "Jyotiba Phule Nagar" },
      { label: "Kadipur", value: "Kadipur" },
      { label: "Kaimganj", value: "Kaimganj" },
      { label: "Kairana", value: "Kairana" },
      { label: "Kaisarganj", value: "Kaisarganj" },
      { label: "Kalpi", value: "Kalpi" },
      { label: "Kannauj", value: "Kannauj" },
      { label: "Kanpur", value: "Kanpur" },
      { label: "Karchhana", value: "Karchhana" },
      { label: "Karhal", value: "Karhal" },
      { label: "Karvi", value: "Karvi" },
      { label: "Kasganj", value: "Kasganj" },
      { label: "Kaushambi", value: "Kaushambi" },
      { label: "Kerakat", value: "Kerakat" },
      { label: "Khaga", value: "Khaga" },
      { label: "Khair", value: "Khair" },
      { label: "Khalilabad", value: "Khalilabad" },
      { label: "Kheri", value: "Kheri" },
      { label: "Konch", value: "Konch" },
      { label: "Kumaon", value: "Kumaon" },
      { label: "Kunda", value: "Kunda" },
      { label: "Kushinagar", value: "Kushinagar" },
      { label: "Lalganj", value: "Lalganj" },
      { label: "Lalitpur", value: "Lalitpur" },
      { label: "Lucknow", value: "Lucknow" },
      { label: "Machlishahar", value: "Machlishahar" },
      { label: "Maharajganj", value: "Maharajganj" },
      { label: "Mahoba", value: "Mahoba" },
      { label: "Mainpuri", value: "Mainpuri" },
      { label: "Malihabad", value: "Malihabad" },
      { label: "Mariyahu", value: "Mariyahu" },
      { label: "Math", value: "Math" },
      { label: "Mathura", value: "Mathura" },
      { label: "Mau", value: "Mau" },
      { label: "Maudaha", value: "Maudaha" },
      { label: "Maunathbhanjan", value: "Maunathbhanjan" },
      { label: "Mauranipur", value: "Mauranipur" },
      { label: "Mawana", value: "Mawana" },
      { label: "Meerut", value: "Meerut" },
      { label: "Mehraun", value: "Mehraun" },
      { label: "Meja", value: "Meja" },
      { label: "Mirzapur", value: "Mirzapur" },
      { label: "Misrikh", value: "Misrikh" },
      { label: "Modinagar", value: "Modinagar" },
      { label: "Mohamdabad", value: "Mohamdabad" },
      { label: "Mohamdi", value: "Mohamdi" },
      { label: "Moradabad", value: "Moradabad" },
      { label: "Musafirkhana", value: "Musafirkhana" },
      { label: "Muzaffarnagar", value: "Muzaffarnagar" },
      { label: "Nagina", value: "Nagina" },
      { label: "Najibabad", value: "Najibabad" },
      { label: "Nakur", value: "Nakur" },
      { label: "Nanpara", value: "Nanpara" },
      { label: "Naraini", value: "Naraini" },
      { label: "Naugarh", value: "Naugarh" },
      { label: "Nawabganj", value: "Nawabganj" },
      { label: "Nighasan", value: "Nighasan" },
      { label: "Noida", value: "Noida" },
      { label: "Orai", value: "Orai" },
      { label: "Padrauna", value: "Padrauna" },
      { label: "Pahasu", value: "Pahasu" },
      { label: "Patti", value: "Patti" },
      { label: "Pharenda", value: "Pharenda" },
      { label: "Phoolpur", value: "Phoolpur" },
      { label: "Phulpur", value: "Phulpur" },
      { label: "Pilibhit", value: "Pilibhit" },
      { label: "Pitamberpur", value: "Pitamberpur" },
      { label: "Powayan", value: "Powayan" },
      { label: "Pratapgarh", value: "Pratapgarh" },
      { label: "Puranpur", value: "Puranpur" },
      { label: "Purwa", value: "Purwa" },
      { label: "Raibareli", value: "Raibareli" },
      { label: "Rampur", value: "Rampur" },
      { label: "Ramsanehi Ghat", value: "Ramsanehi Ghat" },
      { label: "Rasara", value: "Rasara" },
      { label: "Rath", value: "Rath" },
      { label: "Robertsganj", value: "Robertsganj" },
      { label: "Sadabad", value: "Sadabad" },
      { label: "Safipur", value: "Safipur" },
      { label: "Sagri", value: "Sagri" },
      { label: "Saharanpur", value: "Saharanpur" },
      { label: "Sahaswan", value: "Sahaswan" },
      { label: "Sahjahanpur", value: "Sahjahanpur" },
      { label: "Saidpur", value: "Saidpur" },
      { label: "Salempur", value: "Salempur" },
      { label: "Salon", value: "Salon" },
      { label: "Sambhal", value: "Sambhal" },
      { label: "Sandila", value: "Sandila" },
      { label: "Sant Kabir Nagar", value: "Sant Kabir Nagar" },
      { label: "Sant Ravidas Nagar", value: "Sant Ravidas Nagar" },
      { label: "Sardhana", value: "Sardhana" },
      { label: "Shahabad", value: "Shahabad" },
      { label: "Shahganj", value: "Shahganj" },
      { label: "Shahjahanpur", value: "Shahjahanpur" },
      { label: "Shikohabad", value: "Shikohabad" },
      { label: "Shravasti", value: "Shravasti" },
      { label: "Siddharthnagar", value: "Siddharthnagar" },
      { label: "Sidhauli", value: "Sidhauli" },
      { label: "Sikandra Rao", value: "Sikandra Rao" },
      { label: "Sikandrabad", value: "Sikandrabad" },
      { label: "Sitapur", value: "Sitapur" },
      { label: "Siyana", value: "Siyana" },
      { label: "Sonbhadra", value: "Sonbhadra" },
      { label: "Soraon", value: "Soraon" },
      { label: "Sultanpur", value: "Sultanpur" },
      { label: "Tanda", value: "Tanda" },
      { label: "Tarabganj", value: "Tarabganj" },
      { label: "Tilhar", value: "Tilhar" },
      { label: "Unnao", value: "Unnao" },
      { label: "Utraula", value: "Utraula" },
      { label: "Varanasi", value: "Varanasi" },
      { label: "Zamania", value: "Zamania" },
    ],
  },
  {
    label: "Uttaranchal",
    title: "Uttaranchal",
    options: [
      { label: "Almora", value: "Almora" },
      { label: "Bageshwar", value: "Bageshwar" },
      { label: "Bhatwari", value: "Bhatwari" },
      { label: "Chakrata", value: "Chakrata" },
      { label: "Chamoli", value: "Chamoli" },
      { label: "Champawat", value: "Champawat" },
      { label: "Dehradun", value: "Dehradun" },
      { label: "Deoprayag", value: "Deoprayag" },
      { label: "Dharchula", value: "Dharchula" },
      { label: "Dunda", value: "Dunda" },
      { label: "Haldwani", value: "Haldwani" },
      { label: "Haridwar", value: "Haridwar" },
      { label: "Joshimath", value: "Joshimath" },
      { label: "Karan Prayag", value: "Karan Prayag" },
      { label: "Kashipur", value: "Kashipur" },
      { label: "Khatima", value: "Khatima" },
      { label: "Kichha", value: "Kichha" },
      { label: "Lansdown", value: "Lansdown" },
      { label: "Munsiari", value: "Munsiari" },
      { label: "Mussoorie", value: "Mussoorie" },
      { label: "Nainital", value: "Nainital" },
      { label: "Pantnagar", value: "Pantnagar" },
      { label: "Partapnagar", value: "Partapnagar" },
      { label: "Pauri Garhwal", value: "Pauri Garhwal" },
      { label: "Pithoragarh", value: "Pithoragarh" },
      { label: "Purola", value: "Purola" },
      { label: "Rajgarh", value: "Rajgarh" },
      { label: "Ranikhet", value: "Ranikhet" },
      { label: "Roorkee", value: "Roorkee" },
      { label: "Rudraprayag", value: "Rudraprayag" },
      { label: "Tehri Garhwal", value: "Tehri Garhwal" },
      { label: "Udham Singh Nagar", value: "Udham Singh Nagar" },
      { label: "Ukhimath", value: "Ukhimath" },
      { label: "Uttarkashi", value: "Uttarkashi" },
    ],
  },
  {
    label: "West Bengal",
    title: "West Bengal",
    options: [
      { label: "Adra", value: "Adra" },
      { label: "Alipurduar", value: "Alipurduar" },
      { label: "Amlagora", value: "Amlagora" },
      { label: "Arambagh", value: "Arambagh" },
      { label: "Asansol", value: "Asansol" },
      { label: "Balurghat", value: "Balurghat" },
      { label: "Bankura", value: "Bankura" },
      { label: "Bardhaman", value: "Bardhaman" },
      { label: "Basirhat", value: "Basirhat" },
      { label: "Berhampur", value: "Berhampur" },
      { label: "Bethuadahari", value: "Bethuadahari" },
      { label: "Birbhum", value: "Birbhum" },
      { label: "Birpara", value: "Birpara" },
      { label: "Bishanpur", value: "Bishanpur" },
      { label: "Bolpur", value: "Bolpur" },
      { label: "Bongoan", value: "Bongoan" },
      { label: "Bulbulchandi", value: "Bulbulchandi" },
      { label: "Burdwan", value: "Burdwan" },
      { label: "Calcutta", value: "Calcutta" },
      { label: "Canning", value: "Canning" },
      { label: "Champadanga", value: "Champadanga" },
      { label: "Contai", value: "Contai" },
      { label: "Cooch Behar", value: "Cooch Behar" },
      { label: "Daimond Harbour", value: "Daimond Harbour" },
      { label: "Dalkhola", value: "Dalkhola" },
      { label: "Dantan", value: "Dantan" },
      { label: "Darjeeling", value: "Darjeeling" },
      { label: "Dhaniakhali", value: "Dhaniakhali" },
      { label: "Dhuliyan", value: "Dhuliyan" },
      { label: "Dinajpur", value: "Dinajpur" },
      { label: "Dinhata", value: "Dinhata" },
      { label: "Durgapur", value: "Durgapur" },
      { label: "Gangajalghati", value: "Gangajalghati" },
      { label: "Gangarampur", value: "Gangarampur" },
      { label: "Ghatal", value: "Ghatal" },
      { label: "Guskara", value: "Guskara" },
      { label: "Habra", value: "Habra" },
      { label: "Haldia", value: "Haldia" },
      { label: "Harirampur", value: "Harirampur" },
      { label: "Harishchandrapur", value: "Harishchandrapur" },
      { label: "Hooghly", value: "Hooghly" },
      { label: "Howrah", value: "Howrah" },
      { label: "Islampur", value: "Islampur" },
      { label: "Jagatballavpur", value: "Jagatballavpur" },
      { label: "Jalpaiguri", value: "Jalpaiguri" },
      { label: "Jhalda", value: "Jhalda" },
      { label: "Jhargram", value: "Jhargram" },
      { label: "Kakdwip", value: "Kakdwip" },
      { label: "Kalchini", value: "Kalchini" },
      { label: "Kalimpong", value: "Kalimpong" },
      { label: "Kalna", value: "Kalna" },
      { label: "Kandi", value: "Kandi" },
      { label: "Karimpur", value: "Karimpur" },
      { label: "Katwa", value: "Katwa" },
      { label: "Kharagpur", value: "Kharagpur" },
      { label: "Khatra", value: "Khatra" },
      { label: "Krishnanagar", value: "Krishnanagar" },
      { label: "Mal Bazar", value: "Mal Bazar" },
      { label: "Malda", value: "Malda" },
      { label: "Manbazar", value: "Manbazar" },
      { label: "Mathabhanga", value: "Mathabhanga" },
      { label: "Medinipur", value: "Medinipur" },
      { label: "Mekhliganj", value: "Mekhliganj" },
      { label: "Mirzapur", value: "Mirzapur" },
      { label: "Murshidabad", value: "Murshidabad" },
      { label: "Nadia", value: "Nadia" },
      { label: "Nagarakata", value: "Nagarakata" },
      { label: "Nalhati", value: "Nalhati" },
      { label: "Nayagarh", value: "Nayagarh" },
      { label: "Parganas", value: "Parganas" },
      { label: "Purulia", value: "Purulia" },
      { label: "Raiganj", value: "Raiganj" },
      { label: "Rampur Hat", value: "Rampur Hat" },
      { label: "Ranaghat", value: "Ranaghat" },
      { label: "Seharabazar", value: "Seharabazar" },
      { label: "Siliguri", value: "Siliguri" },
      { label: "Suri", value: "Suri" },
      { label: "Takipur", value: "Takipur" },
      { label: "Tamluk", value: "Tamluk" },
    ],
  },
];

const stateOptions = [
  {
    label: "Gujarat",
    value: "Gujarat",
  },
  {
    label: "Maharashtra",
    value: "Maharashtra",
  },
  {
    label: "Rajasthan",
    value: "Rajasthan",
  },
  {
    label: "Karnataka",
    value: "Karnataka",
  },
  {
    label: "Tamil Nadu",
    value: "Tamil Nadu",
  },
  {
    label: "Kerala",
    value: "Kerala",
  },
  {
    label: "Uttar Pradesh",
    value: "Uttar Pradesh",
  },
  {
    label: "West Bengal",
    value: "West Bengal",
  },
  {
    label: "Punjab",
    value: "Punjab",
  },
  {
    label: "Haryana",
    value: "Haryana",
  },
  {
    label: "Bihar",
    value: "Bihar",
  },
  {
    label: "Madhya Pradesh",
    value: "Madhya Pradesh",
  },
  {
    label: "Telangana",
    value: "Telangana",
  },
  {
    label: "Andhra Pradesh",
    value: "Andhra Pradesh",
  },
  {
    label: "Odisha",
    value: "Odisha",
  },
  {
    label: "Assam",
    value: "Assam",
  },
  {
    label: "Jharkhand",
    value: "Jharkhand",
  },
  {
    label: "Chhattisgarh",
    value: "Chhattisgarh",
  },
  {
    label: "Uttarakhand",
    value: "Uttarakhand",
  },
  {
    label: "Himachal Pradesh",
    value: "Himachal Pradesh",
  },
  {
    label: "Goa",
    value: "Goa",
  },
  {
    label: "Tripura",
    value: "Tripura",
  },
  {
    label: "Meghalaya",
    value: "Meghalaya",
  },
  {
    label: "Manipur",
    value: "Manipur",
  },
  {
    label: "Nagaland",
    value: "Nagaland",
  },
  {
    label: "Arunachal Pradesh",
    value: "Arunachal Pradesh",
  },
  {
    label: "Mizoram",
    value: "Mizoram",
  },
  {
    label: "Sikkim",
    value: "Sikkim",
  },
  {
    label: "Andaman and Nicobar Islands",
    value: "Andaman and Nicobar Islands",
  },
  {
    label: "Chandigarh",
    value: "Chandigarh",
  },
  {
    label: "Dadra and Nagar Haveli and Daman and Diu",
    value: "Dadra and Nagar Haveli and Daman and Diu",
  },
  {
    label: "Delhi",
    value: "Delhi",
  },
  {
    label: "Lakshadweep",
    value: "Lakshadweep",
  },
  {
    label: "Puducherry",
    value: "Puducherry",
  },
  {
    label: "Ladakh",
    value: "Ladakh",
  },
  {
    label: "Jammu and Kashmir",
    value: "Jammu and Kashmir",
  },
];

export { cityOptions, stateOptions };
